import {makeOwnDisplayName} from '../adjustment-pricing-grid/services/portfolio-groups';
import {ChangeDetectorRef, Component, EventEmitter, HostListener, ViewChild} from '@angular/core';
import {
    BodyScrollEvent,
    CellClassParams,
    CellClickedEvent,
    ColDef,
    ColGroupDef,
    Column,
    GetContextMenuItemsParams,
    GridApi,
    GridOptions,
    GridReadyEvent,
    RowNode
} from 'ag-grid-community';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {DxPopupComponent} from 'devextreme-angular/ui/popup';
import {OrionWindowController} from '../copilot-shared/orion-window.controller';
import {ToastrService} from 'ngx-toastr';
import {interval, of, Subject, Subscription} from 'rxjs';
import {auditTime, debounce, debounceTime, filter, takeUntil} from 'rxjs/operators';
import {LastQuoteCacheService} from '../last-quote-cache.service';
import {MessageBusService} from '../message-bus.service';
import {OptionsChainService} from '../option-chains.service';
import {QuoteDto} from '../shell-communication/dtos/quote-dto.class';
import {TradingInstrument} from '../trading-instruments/trading-instrument.class';
import {
    jsonCloneObject,
    DetectMethodChanges,
    DxValueChanged,
    findAtmStrikeIndex,
    getShortUUID,
    isCashSettledOptionTicker,
    isFuturesTicker,
    isNullOrUndefined,
    isOptionExpired,
    isValidNumber,
    isVoid,
    wrapInPromise, getStrikeStep, strictParseInt
} from '../utils';
import {HorizontalSkewPrefs, HorizontalSkewPrefsStore} from '../horizontal-skew/horizontal-skew-cqrs.model';
import {HorizontalSkewService} from '../horizontal-skew/horizontal-skew.service';
import {getGridColumnDefinitions, getOptionsPricingGridModel} from './options-pricing-grid-options';
import {PricingGridStrategy} from './model/pricing-grid.strategy';
import {makeOptionDisplayName, OptionType, parseOptionTicker} from '../options-common/options.model';
import {ComboHighlightedItem, ComboHighlightedUIMessage, SymbolHighlighted} from '../ui-messages/ui-messages';
import {TimeInForce} from '../trading-model/time-in-force.enum';
import {OrderType} from '../trading-model/order-type.enum';
import {ClipboardService, ETS_CLIPBOARD_LEGS_KEY} from '../clipboard.service';
import {MarketSide} from '../trading-model/market-side.enum';
import {
    GetOptionChainShellResponse,
    GreeksDto,
    OptionExpirationDescriptor,
    ResubscribeOptionStrategiesDto,
    StrategyPriceDto
} from '../shell-communication/shell-dto-protocol';
import {TradingInstrumentsService} from '../trading-instruments/trading-instruments-service.interface';
import {SymbolPickerComponent} from '../symbol-picker/symbol-picker.component';
import {PortfolioItemType} from '../portfolios/portfolios.model';
import {PanelBaseComponent} from '../panels/panel-base.component';
import {OpgTemplate, OptionPricingGridTemplatesService} from "./option-pricing-grid-templates.service";
import {OpgEditTemplatePopupModel} from "./OpgEditTemplatePopupModel";
import {DateTime} from "luxon-business-days";
import {AccessControlService} from "../access-control-service.class";
import {GenericConfirmationDialogComponent} from "../generic-confirmation-dialog/generic-confirmation-dialog.component";
import {PricingGridLegDescriptor} from "./model/pricing-grid-leg.descriptor";
import {GridSettingsProvider} from "./model/grid-settings.provider";
import {PricingGridStrategyColumn} from "./model/pricing-grid-strategy.column";
import {PricingGridRow} from "./model/pricing-grid.row";
import {PricingGridStrategyDescriptor} from "./model/pricing-grid-strategy.descriptor";
import {ServiceConfiguration} from "../adjustment-pricing-grid/services/ServiceConfiguration";
import {SessionService} from "../authentication/session-service.service";
import {CashFlowPortfoliosService} from "../adjustment-pricing-grid/services/cashflow-portfolios.service";
import {UserDto} from "../authentication/dtos/auth-result-dto.inteface";
import {ApgPortfolio} from "../adjustment-pricing-grid/model/ApgPortfolio";
import * as Enumerable from "linq";
import {HedgePositionsService} from "../hedging-grid/positions-section/hedge-positions/hedge-positions.service";
import {HedgePosition} from "../hedging-grid/data-model/hedge-position";
import {CustomHedgeLeg} from "./model/custom-hedge-leg";
import {HedgesPricingService} from "../package-comparison/services/hedges-pricing.service";
import {OrdersVerificationDialogComponent} from "./orders-verification-dialog/orders-verification-dialog.component";
import {OrdersVerificationDialogConfig} from "./orders-verification-dialog/orders-verification-dialog.config";
import {UserSettingsService} from "../user-settings.service";
import {ApgDataService} from "../adjustment-pricing-grid/services/apg-data.service";
import {findOffsetExpiration} from "../hedging-grid/hedge-matrix/hedge-matrix-data.service";
import {OpgAssignTemplatesComponent} from "./assign-templates/opg-assign-templates.component";
import {ExpectedMoveService} from "../expected-move/expected-move.service";
import {AppSettingsUpdatedMessageTopic} from "../app-settings/application-settings.service";
import {AtmStrikeService} from "../common-services/atm-strike-service/atm-strike.service";
import {AtmStrikeChangedEvent} from "../common-services/atm-strike-service/atm-strike-changed-event";
import {OpgTestingService} from "./opg-testing/opg-testing.service";
import {ShellClientService} from "../shell-communication/shell-client.service";
import {IvCacheService} from "../iv-cache.service";
import {TradingInstrumentDisplayNameService} from "../trading-instruments/trading-instrument-display-name.service";
import {SubscribeVerticalSkew, UnsubscribeVerticalSkew, VerticalSkewChangedDto} from "../skew-meter/skew-meter-cqrs.model";
import {ToolbarVisibilityManager} from "./toolbar-visibility/toolbar-visibility-manager";
import {TOOLBAR_ELEMENT_CATALOG} from "./toolbar-visibility/toolbar-visibility-catalog";
import {ToolbarVisibilityDialogComponent} from "./toolbar-visibility/toolbar-visibility-dialog.component";
import {IOpgCopilotFacade} from "../copilot-shared/opg-copilot-facade";
import {OpgSide, OpgTradeContent} from "../copilot-shared/opg-copilot-domain";
import {OpgCopilotComponent} from "../copilot-shared/opg-copilot.component";

type OpgStateKey = 'opg.symbol' | 'opg.expiration' | 'opg.step' | 'opg.num-of-strikes' | 'opg.center-strike'
    | 'opg.call-range-start' | 'opg.call-range-end' | 'opg.put-range-start' | 'opg.put-range-end'
    | 'opg.call-offset' | 'opg.call-range' | 'opg.put-offset' | 'opg.put-range' | 'opg.is-custom-range'
    | 'opg.default-qty.own' | 'opg.default-qty.custom';

interface CustomColumnDialogConfig {
    visible?: boolean;
    header?: string;
    spreadWidth?: number;
}

interface PanelState {
    isLinkedToSymbol: boolean;
}

export type OptionPricingGridMode = 'opg' | 'pmd';

export interface OpgExpirationChangeMessage {
    component: OptionsPricingGridComponentBase
}

export interface OpgCellSelectedMessage {
    component: OptionsPricingGridComponentBase
}

// Per-DTO diagnostic logs — muted by default (high volume on active expirations).
// Flip to true to re-enable for skew-meter / IV pipeline debugging.
const VERTICAL_SKEW_TRACE = false;
const IV_DEBOUNCE_TRACE = false;

@Component({
    selector: 'grid-base',
    template: ''
})
export abstract class OptionsPricingGridComponentBase extends PanelBaseComponent implements GridSettingsProvider, IOpgCopilotFacade {
    protected constructor(
        protected readonly _changeDetector: ChangeDetectorRef,
        protected readonly _userSettingsService: UserSettingsService,
        protected readonly _messageBus: MessageBusService,
        private _lastQuoteCache: LastQuoteCacheService,
        private _optionsChainService: OptionsChainService,
        private _toastr: ToastrService,
        private _clipboardService: ClipboardService,
        private _tiService: TradingInstrumentsService,
        private _templatesService: OptionPricingGridTemplatesService,
        public readonly accessControlService: AccessControlService,
        private readonly _sessionService: SessionService,
        private readonly _portfolioService: CashFlowPortfoliosService,
        private readonly _apgDataService: ApgDataService,
        private readonly _hedgePositionService: HedgePositionsService,
        private readonly _expectedMoveService: ExpectedMoveService,
        private readonly _atmStrikeService: AtmStrikeService,
        private readonly _opgTestingService: OpgTestingService,
        private readonly _shellClient: ShellClientService,
        private readonly _displayNameService: TradingInstrumentDisplayNameService,
        private readonly _ivCacheService: IvCacheService,
        private readonly _horizontalSkew: HorizontalSkewService,
    ) {
        super(_changeDetector, _userSettingsService, _messageBus);

        this.editTemplatePopupModel = new OpgEditTemplatePopupModel(_changeDetector, _toastr);

        this._hedgesPricingService = new HedgesPricingService(
            _hedgePositionService,
            _lastQuoteCache,
            _messageBus,
            _apgDataService
        );
    }

    private _unsubscriber = new Subject();
    private _grid: GridReadyEvent;
    private _rowsByStrategyCode: Record<string, PricingGridRow> = {};
    private readonly _hedgesPricingService: HedgesPricingService;
    private _qgCursorDate: string = null;
    // Widths the USER set by dragging a column divider. Engine-measured widths are
    // deliberately absent -- see onColumnResized in options-pricing-grid-options.ts.
    private _userPricingColumnWidths = new Map<string, number>();
    private _ivRefreshTimerSub: Subscription = null;
    private _isQgHistoryMode = false;

    abstract mode: OptionPricingGridMode;

    @ViewChild(SymbolPickerComponent) symbolPicker: SymbolPickerComponent;

    @ViewChild(GenericConfirmationDialogComponent) confirmationDialogCmp: GenericConfirmationDialogComponent;

    @ViewChild(OpgAssignTemplatesComponent) assignTemplatesDialog: OpgAssignTemplatesComponent;

    @ViewChild(ToolbarVisibilityDialogComponent) toolbarVisibilityDialog: ToolbarVisibilityDialogComponent;

    private _visibilityManager: ToolbarVisibilityManager;

    get visibilityManager(): ToolbarVisibilityManager {
        if (!this._visibilityManager) {
            this._visibilityManager = new ToolbarVisibilityManager(this._userSettingsService, this.mode);
        }
        return this._visibilityManager;
    }

    isElementVisible(elementKey: string): boolean {
        return this.visibilityManager.isVisible(elementKey);
    }

    async openToolbarVisibilityDialog(): Promise<void> {
        if (!this.toolbarVisibilityDialog) {
            return;
        }
        const descriptors = TOOLBAR_ELEMENT_CATALOG.filter(d => d.modes.indexOf(this.mode) >= 0);
        const applied = await this.toolbarVisibilityDialog.show(this.visibilityManager, descriptors);
        if (applied) {
            this._changeDetector.detectChanges();
        }
    }

    get expectedMoveService(): ExpectedMoveService {
        return this._expectedMoveService;
    }

    get toastr(): ToastrService {
        return this._toastr;
    }

    impliedVolatility: number = null;
    ivLoading = false;
    ivError = false;

    skewMeterCallSkew: number = null;
    skewMeterPutSkew: number = null;
    skewMeterCallLoading = false;
    skewMeterPutLoading = false;

    expectedRangeText = '';
    private _expectedRangeHeaderHeight: number;

    @DetectMethodChanges({isAsync: true})
    async fetchImpliedVolatility(): Promise<void> {
        if (isVoid(this.tradingInstrument) || isVoid(this.selectedExpiration)) {
            this.impliedVolatility = null;
            this.ivLoading = false;
            this.ivError = false;
            this.skewMeterCallSkew = null;
            this.skewMeterPutSkew = null;
            this.skewMeterCallLoading = false;
            this.skewMeterPutLoading = false;
            return;
        }

        if (this.impliedVolatility == null) {
            this.ivLoading = true;
        }
        this.ivError = false;

        try {
            // Routed through IvCacheService so HM cells + APG header + this OPG header
            // sharing the same (underlying, expiration) coalesce to one HTTP per TTL.
            const reply = await this._ivCacheService.getIv(
                this.tradingInstrument.ticker,
                this.selectedExpiration.optionExpirationDate
            );
            this.impliedVolatility = reply.volatility;
        } catch {
            if (this.impliedVolatility == null) {
                this.ivError = true;
            }
        } finally {
            this.ivLoading = false;
        }
    }

    // region Skew Meter — backend-driven vertical skew

    private subscribeSkewMeter(underlying?: string, expiration?: string): void {
        const ul = underlying || this.tradingInstrument?.ticker;
        const exp = expiration || this.selectedExpiration?.optionExpirationDate;

        if (isVoid(ul) || isVoid(exp)) {
            return;
        }

        console.log(`[VerticalSkew] Subscribe: ${ul}|${exp}`);
        this._shellClient.processCommand(new SubscribeVerticalSkew(ul, exp));
    }

    private unsubscribeSkewMeter(underlying?: string, expiration?: string): void {
        const ul = underlying || this.tradingInstrument?.ticker;
        const exp = expiration || this.selectedExpiration?.optionExpirationDate;
        if (ul && exp) {
            console.log(`[VerticalSkew] Unsubscribe: ${ul}|${exp}`);
            try {
                this._shellClient.processCommand(new UnsubscribeVerticalSkew(ul, exp));
            } catch (e) {
                // Session may already be invalidated during logout — backend CleanupSession handles cleanup
                console.log(`[VerticalSkew] Unsubscribe failed (session ended?): ${e}`);
            }
        }
    }

    // endregion Skew Meter

    // region Horizontal Skew (term structure) — per-panel surface (CR-20260701-001, R3)

    // Stable persistence seam for the per-panel Horizontal-Skew service (base-inited).
    // Settings are PER SYMBOL (owner, 2026-07-02): every symbol keeps its own picked
    // legs/basis under `${ticker}.opg.hskew` (the `${ticker}.opg.*` key family), shared
    // by all OPG panels showing that symbol; first use starts at the 30/90 defaults.
    readonly hsPrefsStore: HorizontalSkewPrefsStore = {
        load: (underlying: string) =>
            this._userSettingsService.getValue<HorizontalSkewPrefs>(`${underlying}.opg.hskew`) || null,
        save: (underlying: string, prefs: HorizontalSkewPrefs) =>
            this._userSettingsService.setValue(`${underlying}.opg.hskew`, prefs)
    };

    // The service instance is provided by the CONCRETE panel components (opg + pmd) —
    // one per panel. Both header indicator views inject that same instance; the base
    // owns its lifecycle (init / setUnderlying / dispose), so the views stay pure.
    private _hsInited = false;

    /** Collapsed-strip display value (the expanded boxes render inside the indicator views). */
    get hSkewDisplay(): string {
        return this._horizontalSkew.ratio != null ? this._horizontalSkew.ratio.toFixed(2) : 'N/A';
    }

    get hSkewLoading(): boolean {
        return this._horizontalSkew.loading;
    }

    // init() on the first symbol, setUnderlying() on later switches — called from
    // setNewSymbol, the single place `tradingInstrument` is assigned.
    private syncHorizontalSkew(): void {
        const ticker = this.tradingInstrument?.ticker;
        if (!ticker) {
            return;
        }
        if (!this._hsInited) {
            this._hsInited = true;
            this._horizontalSkew.init(ticker, this.hsPrefsStore);
        } else {
            this._horizontalSkew.setUnderlying(ticker);
        }
    }

    // endregion Horizontal Skew

    // region Expected Range Display

    private updateExpectedRangeDisplay(): void {
        const expiration = this.selectedExpiration;
        this.expectedRangeText = this._expectedMoveService.getDisplayText({
            source: 'OPG', column: undefined, strike: undefined,
            ticker: this.tradingInstrument?.ticker,
            underlyingTicker: expiration?.underlyingTicker,
            expirationTicker: expiration?.expirationTicker,
            expiration: expiration?.optionExpirationDate
        });
        if (this._grid) {
            const height = this.expectedRangeText.indexOf('\n') >= 0 ? 48 : undefined;
            if (height !== this._expectedRangeHeaderHeight) {
                this._expectedRangeHeaderHeight = height;
                this._grid.api.setGroupHeaderHeight(height);
            }
            if (this.expectedRangeText && this._expectedMoveService.hasExtendedDisplay()) {
                const col = this._grid.columnApi?.getColumn('strikeColumn');
                if (col && col.getActualWidth() < 220) { this._grid.columnApi.setColumnWidth(col, 220); }
            }
            this._grid.api.refreshCells({columns: ['strikeColumn', 'strikeColumn2'], force: true});
            this._grid.api.refreshHeader();
        }
    }

    // endregion Expected Range Display

    private onQgCursorDateChanged(payload: { ticker: string, cursorDate: string }): void {
        if (isVoid(payload?.cursorDate)) {
            this._qgCursorDate = null;
            return;
        }

        const newDate = payload.cursorDate.split('T')[0];

        if (this._qgCursorDate === newDate) {
            return;
        }

        this._qgCursorDate = newDate;
        console.log(`[IV] Cursor date changed to ${newDate}, deferring IV fetch to QuoteDto debounce`);
    }

    optionChain: GetOptionChainShellResponse;

    // When on, adding/removing a strategy or applying a template scrolls the grid to
    // the side that was acted on. Named for what it does: this flag has NEVER affected
    // column widths -- auto-sizing runs unconditionally. Was misleadingly called
    // 'autoSizeColumns'.
    autoScrollToTargetSide = true;

    showPnl = false;

    showPnl2 = false;

    callsLiveMode = false;

    putsLiveMode = false;

    strategiesList = new DataSource({
        store: new ArrayStore({
            key: 'strategy',
            data: [
                {strategy: '1 Leg', category: 'Raw'},
                {strategy: '2 Legs', category: 'Raw'},
                {strategy: '3 Legs', category: 'Raw'},
                {strategy: '4 Legs', category: 'Raw'},
                {strategy: '6 Legs', category: 'Raw'},
                {strategy: '8 Legs', category: 'Raw'},
                {strategy: 'BOS', category: 'Templates'},
                {strategy: 'BOS-Mid', category: 'Templates'},
                {strategy: 'Butterfly', category: 'Templates'},
                {strategy: 'Condor', category: 'Templates'},
                {strategy: 'Slingshot', category: 'Templates'},
                {strategy: 'Slingshot - Modified', category: 'Templates'},
                {strategy: 'Sponsored Long', category: 'Templates'},
                {strategy: 'Vertical', category: 'Templates'},
            ]
        }),
        group: 'category'
    });

    // selectedCell: CellClickedEvent;
    selectedCallCell: CellClickedEvent;
    selectedPutCell: CellClickedEvent;

    customColumnDialogConfig: CustomColumnDialogConfig = {};

    lastPx: number;

    numOfStrikes: number;

    strikeStep: number;

    centerStrike: number;

    private _isSwitchingSymbol = false;

    tradingInstrument: TradingInstrument;

    gridOptions: GridOptions;

    pricingRows: PricingGridRow[] = [];

    selectedExpiration: OptionExpirationDescriptor;

    percentageProfit: number;

    availableExpirations: OptionExpirationDescriptor[] = [];

    dataStoreExpirations = [];

    isCustomRange = false;

    callOffset: number;

    callRange: number;

    callsTargetRangeStart: number;

    callsTargetRangeEnd: number;

    callsPropagateRange = false;

    putsTargetRangeStart: number;

    putsTargetRangeEnd: number;

    putOffset: number;

    putRange: number;

    putsPropagateRange = false;

    rMultiple: number;

    callStrategies: PricingGridStrategy[] = [];

    putStrategies: PricingGridStrategy[] = [];

    showItmData = false;

    pricingMode = false;
    private _showItmDataBeforePricingMode = false;

    gridMode: 'Single' | 'Comparison' = 'Comparison';

    callsSelectedTemplate: OpgTemplate;

    putsSelectedTemplate: OpgTemplate;

    editTemplatePopupModel: OpgEditTemplatePopupModel;

    putsSidePanelVisible = true;

    callsSidePanelVisible = true;

    portfolioList: { key: string, userId: string, items: ApgPortfolio[] }[];

    selectedCallsPortfolio: ApgPortfolio;

    selectedPutsPortfolio: ApgPortfolio;

    callHedgesList: { id: string, label: string, items: HedgePosition[] }[];

    selectedCallHedge: { id: string, label: string, items: HedgePosition[] };

    putHedgesList: { id: string, label: string, items: HedgePosition[] }[];

    selectedPutHedge: { id: string, label: string, items: HedgePosition[] };

    defaultQty: number = 1;

    hedgingMode: boolean = false;

    get isEsFuturesUnderlying(): boolean {
        return this.tradingInstrument
            && isFuturesTicker(this.tradingInstrument.ticker)
            && this.tradingInstrument.ticker.startsWith('ES');
    }

    strategyApplied$ = new EventEmitter();

    get showTotalCostFloater() {
        return this.bothSidesHasSelected();
    }

    get strikeLadderStep(): number {
        return getStrikeStep(this.tradingInstrument?.ticker);
    }

    get customCallHedgeOffsetsAreFine(): boolean {
        if (isVoid(this.customCallHedgeLegs)) {
            return true;
        }

        const noCal = this.customCallHedgeLegs.every(x => !isValidNumber(x.expirationOffset));

        if (noCal) {
            return true;
        }

        const hasBrokenLegs = this.customCallHedgeLegs.map(x => x.asHedgePosition()).some(x => isVoid(x));

        return !hasBrokenLegs;
    }

    get customPutHedgeOffsetsAreFine(): boolean {
        if (isVoid(this.customPutHedgeLegs)) {
            return true;
        }

        const noCal = this.customPutHedgeLegs.every(x => !isValidNumber(x.expirationOffset));

        if (noCal) {
            return true;
        }

        const hasBrokenLegs = this.customPutHedgeLegs.map(x => x.asHedgePosition()).some(x => isVoid(x));

        return !hasBrokenLegs;
    }

    get atmStrikeService(): AtmStrikeService {
        return this._atmStrikeService;
    }

    @ViewChild(OrdersVerificationDialogComponent)
    orderVerificationDialog: OrdersVerificationDialogComponent;

    get expiration(): OptionExpirationDescriptor {
        return this.selectedExpiration;
    }


    get atmStrike(): number {
        return this.centerStrike;
    }


    get lastQuoteCache(): LastQuoteCacheService {
        return this._lastQuoteCache;
    }


    get gridApi(): GridApi {
        return this._grid.api;
    }


    get subControlsEnabled(): boolean {
        return !!this.tradingInstrument && !!this.selectedExpiration;
    }

    get showAssignTemplatesButton(): boolean {
        return this._sessionService.sessionData.isSuperUser;
    }


    etsOnInit() {

        this.gridOptions = getOptionsPricingGridModel.bind(this)();

        // Listener lives for the component's lifetime so the very first DTO
        // (loading state or computed result) cannot race against a lazy attach.
        // Self-filters by comparing DTO fields against current OPG state at
        // message-receipt time — closure reads `this.…` fresh per message.
        // Horizontal-Skew pushes repaint the readings this template renders directly
        // (the collapsed-strip boxes); the two <ets-horizontal-skew-panel-indicator>
        // header views repaint themselves off the same service.
        this._horizontalSkew.updated$
            .pipe(takeUntil(this._unsubscriber))
            .subscribe(() => this._changeDetector.detectChanges());

        this._messageBus.of<VerticalSkewChangedDto>('VerticalSkewChangedDto')
            .pipe(takeUntil(this._unsubscriber))
            .subscribe(msg => {
                const dto = msg.payload;
                if (dto.underlying !== this.tradingInstrument?.ticker
                    || dto.expiration !== this.selectedExpiration?.optionExpirationDate) {
                    if (VERTICAL_SKEW_TRACE) {
                        console.log(`[VerticalSkew] DTO filtered: received ${dto.underlying}|${dto.expiration}, watching ${this.tradingInstrument?.ticker}|${this.selectedExpiration?.optionExpirationDate}`);
                    }
                    return;
                }
                if (VERTICAL_SKEW_TRACE) {
                    console.log(`[VerticalSkew] DTO applied: ${dto.underlying}|${dto.expiration} call=${dto.callSkew} put=${dto.putSkew} callLoading=${dto.callLoading} putLoading=${dto.putLoading}`);
                }
                this.skewMeterCallSkew = dto.callSkew;
                this.skewMeterPutSkew = dto.putSkew;
                this.skewMeterCallLoading = dto.callLoading;
                this.skewMeterPutLoading = dto.putLoading;
                this._changeDetector.detectChanges();
            });

        this._messageBus.of<QuoteDto[]>('QuoteDto')
            .pipe(
                takeUntil(this._unsubscriber)
            )
            .subscribe(x => this.onQuote(x.payload));


        this._messageBus.of<GreeksDto>('GreeksDto')
            .pipe(
                takeUntil(this._unsubscriber)
            )
            .subscribe(x => this.onGreeks(x.payload));

        this._messageBus.of<StrategyPriceDto[]>('StrategyPriceDto')
            .pipe(
                takeUntil(this._unsubscriber)
            )
            .subscribe(x => this.onStrategyPriceDto(x.payload));

        this._messageBus
            .of<SymbolHighlighted>('SymbolHighlighted')
            .pipe(
                filter(x => this.isLinkedToSymbol),
                takeUntil(this._unsubscriber)
            )
            .subscribe(x => this.onSymbolHighlightedMessage(x.payload));

        this._messageBus
            .of<ResubscribeOptionStrategiesDto>('ResubscribeOptionStrategiesDto')
            .pipe(
                takeUntil(this._unsubscriber)
            )
            .subscribe(x => this.onResubscribeOptionStrategies(x.payload));


        this._messageBus.of<{ portfolios: ApgPortfolio[] }>('Apg.PortfoliosUpdated')
            .pipe(
                takeUntil(this._unsubscriber)
            )
            .subscribe((msg) => this.onPortfoliosUpdated(msg.payload));


        // this.scrollEvent$.pipe(
        //     debounce(_ => interval(250))
        // )
        //     .pipe(
        //         takeUntil(this._unsubscriber)
        //     )
        //     .subscribe(x => this.onGridScrolled(x))

        this.strategyApplied$.pipe(
            debounce(_ => interval(250))
        )
            .pipe(
                takeUntil(this._unsubscriber)
            ).subscribe(_ => {
            this._messageBus.publishAsync({
                topic: 'Opg.StrategyApplied',
                payload: {
                    component: this
                }
            });

            this._grid?.api.refreshCells({force: true});
        })

        this.initPortfolioService()
            .then(() => {
                this._hedgesPricingService.init();
                this._hedgesPricingService.hedgePriceChanged$
                    .subscribe(() => this._changeDetector.detectChanges())
                this.restoreState();
            })
            .finally(() => {
                this._changeDetector.detectChanges();
            });

        this._messageBus.of<any>('ExpectedMoveRangeChanged')
            .pipe(
                takeUntil(this._unsubscriber)
            ).subscribe(() => {
            if (!this._grid) {
                return;
            }
            this.updateExpectedRangeDisplay();
            this._changeDetector.detectChanges();
        });

        this._messageBus.of(AppSettingsUpdatedMessageTopic)
            .pipe(
                takeUntil(this._unsubscriber)
            ).subscribe(() => {
            this.updateExpectedRangeDisplay();
            this._changeDetector.detectChanges();
        });

        this._messageBus.of<AtmStrikeChangedEvent>('AtmStrikeChangedEvent')
            .pipe(
                takeUntil(this._unsubscriber)
            ).subscribe((msg) => {
            if (!this._grid) {
                return;
            }
            this._grid.api.refreshCells({columns: ['strikeColumn', 'strikeColumn2'], force: true});
        });

        this._messageBus.of<AtmStrikeChangedEvent>('AtmStrikeChangedEvent')
            .pipe(
                debounceTime(2000),
                takeUntil(this._unsubscriber)
            ).subscribe((msg) => {
            if (this.tradingInstrument) {
                if (this.tradingInstrument.underlying === msg.payload.underlying) {
                    this.fetchImpliedVolatility().then(() => {}).catch((e) => console.error(e));
                }
            }
        });

        this._messageBus.of<any>('Qg.CursorDateChangedMessage')
            .pipe(
                takeUntil(this._unsubscriber)
            ).subscribe(msg => this.onQgCursorDateChanged(msg.payload));

        this._messageBus.of<any>('Qg.StreamModeChanged')
            .pipe(takeUntil(this._unsubscriber))
            .subscribe(msg => {
                this._isQgHistoryMode = msg.payload?.mode === 'History';
                this.recreateIvRefreshSub();
            });

        this.recreateIvRefreshSub();

    }


    etsAfterViewInit() {
    }


    @DetectMethodChanges()
    setLiveStatus(targetSide: 'calls' | 'puts', $event: boolean) {
        if (targetSide === 'calls') {
            this.callsLiveMode = $event || false;
        } else if (targetSide === 'puts') {
            this.putsLiveMode = $event || false;
        }

        if ($event) {
            this.applyLiveIfPossible(targetSide);
        }
    }

    getLiveStatus(targetSide: 'calls' | 'puts') {
        if (targetSide === 'calls') return this.callsLiveMode;
        if (targetSide === 'puts') return this.putsLiveMode;
    }

    private onResubscribeOptionStrategies(x: ResubscribeOptionStrategiesDto): void {
        const codesToSubscribe = this.getSubscribedStrategyCodes();
        this.changeOptionStrategiesSubscription([], codesToSubscribe);
    }

    getGroupedTemplates(targetSide: 'calls' | 'puts'): { key: string, items: OpgTemplate[] }[] {
        if (this.isWrongSide(targetSide)) {
            return undefined;
        }

        return targetSide === 'calls'
            ? this._templatesService.getGroupedCallTemplates()
            : this._templatesService.getGroupedPutTemplates();
    }

    getTemplates(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return undefined;
        }

        return targetSide === 'calls'
            ? this._templatesService.getCallTemplates()
            : this._templatesService.getPutTemplates();
    }


    @DetectMethodChanges({isAsync: true})
    async onSymbolHighlightedMessage(x: SymbolHighlighted): Promise<void> {
        console.timeLog('[OPG Restore]', `2. onSymbolHighlightedMessage — ticker=${x.ticker}`);
        const ti = this._tiService.getInstrumentByTicker(x.ticker);
        if (!ti) {
            console.timeLog('[OPG Restore]', '2. onSymbolHighlightedMessage — instrument not found, aborting');
            return;
        }

        try {
            await this.onSymbolSelected(ti);
            this.symbolPicker.selectedInstrument = ti;
        } catch {
            //
        }
    }


    private recreateIvRefreshSub(): void {
        if (this._ivRefreshTimerSub) {
            this._ivRefreshTimerSub.unsubscribe();
        }
        const timeOp = this._isQgHistoryMode ? debounceTime(2000) : auditTime(2000);
        this._ivRefreshTimerSub = this._messageBus.of<any>('QuoteDto')
            .pipe(
                filter(msg => this.tradingInstrument && msg.payload.some(
                    (q: any) => q.ticker === this.tradingInstrument.ticker
                        || q.ticker === this.tradingInstrument.underlying
                )),
                timeOp,
                takeUntil(this._unsubscriber)
            )
            .subscribe(() => {
                if (IV_DEBOUNCE_TRACE) {
                    console.log(`[IV] QuoteDto debounce fired, fetching IV for ${this.tradingInstrument?.ticker}`);
                }
                this.fetchImpliedVolatility().then(() => {}).catch((e) => console.error(e));
            });
    }

    etsOnDestroy(): void {
        this._horizontalSkew.dispose();
        if (this._ivRefreshTimerSub) {
            this._ivRefreshTimerSub.unsubscribe();
            this._ivRefreshTimerSub = null;
        }
        if (this._unsubscriber) {
            this._unsubscriber.next();
            this._unsubscriber.complete();
        }
        this._hedgesPricingService.dispose();
        const codesTounsubscribe = this.getSubscribedStrategyCodes();
        this.changeOptionStrategiesSubscription(codesTounsubscribe, []);
        this.unsubscribeCurrentTickers();
        this.unsubscribeSkewMeter();
    }


    @DetectMethodChanges({isAsync: true})
    async onSymbolSelected(ti: TradingInstrument): Promise<void> {

        console.timeLog('[OPG Restore]', `3. onSymbolSelected — ticker=${ti.ticker}`);

        // Unsubscribe from current vertical skew before underlying+expiration are cleared
        console.log(`[VerticalSkew] onSymbolSelected: switching from ${this.tradingInstrument?.ticker} to ${ti.ticker}`);
        this.unsubscribeSkewMeter();

        this.isLoading = true;
        this._isSwitchingSymbol = true;

        try {

            this.hedgingMode = false;

            this.centerStrike = null;
            this.selectedExpiration = null;
            this.strikeStep = null;
            this.numOfStrikes = null;
            this.impliedVolatility = null;

            console.timeLog('[OPG Restore]', '4. getChain — start');
            this.optionChain = await this._optionsChainService.getChain(ti.ticker);
            console.timeLog('[OPG Restore]', `4. getChain — done (${this.optionChain?.expirations?.length} expirations)`);

            try {

                if (!isVoid(ti)) {
                    this.atmStrikeService.watch(ti.ticker);
                }

                console.timeLog('[OPG Restore]', '5. setNewSymbol — start');
                await this.setNewSymbol(ti);
                console.timeLog('[OPG Restore]', '5. setNewSymbol — done');

            } finally {
                this.isLoading = false;
            }

            if (!isVoid(ti)) {
                this.saveOpgState('opg.symbol', ti.ticker);
                console.timeLog('[OPG Restore]', '6. applyOpgState(ti) — start');
                await this.applyOpgState(ti);
                console.timeLog('[OPG Restore]', '6. applyOpgState(ti) — done');
            }

        } finally {
            this._isSwitchingSymbol = false;
        }
    }

    async onTemplateSelected(targetSide: 'calls' | 'puts', ev: DxValueChanged<OpgTemplate>) {
        try {
            await this.onTemplateSelectedInternal(targetSide, ev);
        } finally {
            this.scrollToTargetSide(targetSide);
        }
    }

    private async onTemplateSelectedInternal(targetSide: 'calls' | 'puts', ev: DxValueChanged<OpgTemplate>) {

        if (this.isWrongSide(targetSide)) {
            return;
        }

        if (isVoid(ev.event)) {
            return;
        }

        this.isLoading = true;

        try {

            await wrapInPromise(async () => {

                let strategies = targetSide === 'calls' ? this.callStrategies : this.putStrategies;
                strategies.forEach(x => this.removeStrategy(targetSide, x));

                if (targetSide === 'calls') {
                    this.callsSelectedTemplate = ev.value;
                } else {
                    this.putsSelectedTemplate = ev.value;
                }

                const selectedTemplate = targetSide === 'calls' ? this.callsSelectedTemplate : this.putsSelectedTemplate;

                if (isVoid(selectedTemplate)) {
                    return;
                }

                selectedTemplate.descriptors.forEach(d => {
                    this.addStrategy(targetSide, d);
                });
            });
        } finally {
            this.isLoading = false;
        }

        if (!this.canApplyAllStrategies(targetSide)) {
            return;
        }

        let shouldApplyAllStrategies: boolean;

        if (targetSide === 'calls') shouldApplyAllStrategies = this.callsLiveMode;
        if (targetSide === 'puts') shouldApplyAllStrategies = this.putsLiveMode;

        if (!shouldApplyAllStrategies) return;

        this.applyAllStrategies(targetSide);
    }

    @DetectMethodChanges()
    addStrategy(targetSide: 'calls' | 'puts', descriptor?: PricingGridStrategyDescriptor): Promise<void> {

        if (targetSide !== 'calls' && targetSide !== 'puts') {
            return Promise.resolve();
        }

        const container = targetSide === 'calls' ? this.callStrategies : this.putStrategies;

        const strategy = new PricingGridStrategy(
            this,
            targetSide,
            descriptor
        );

        if (descriptor) {
            strategy.strategyName = descriptor.strategyName;
            strategy.selectedStrategy = descriptor.selectedStrategy;
            strategy.strategyLegs = jsonCloneObject(descriptor.strategyLegs);
            strategy.width = descriptor.width;
            strategy.markForChanges();
        }

        let nameFound = false;
        let attempt = container.length;

        do {

            attempt += 1;
            let strategyName = strategy.strategyName;

            if (isVoid(strategyName)) {
                strategyName = `Strategy #${attempt}`;
            }

            const ix = container.findIndex(x => x.strategyName === strategyName);

            nameFound = ix === -1;

            if (nameFound) {
                strategy.strategyName = strategyName;
            }

            if (attempt > 1000) {
                break;
            }
        } while (!nameFound);


        const subscription1 = strategy.applyLegsClicked$
            .subscribe((ev) => {
                try {
                    this.onStrategyApplyClicked(targetSide, ev);
                } finally {
                    this.scrollToTargetSide(targetSide);
                }
            });

        const subscription2 = strategy.somethingChanged$
            .subscribe((ev) => this.onStrategySomethingChanged(ev));

        const subscription3 = strategy.callDetectChanges$
            .subscribe((ev) => this._changeDetector.detectChanges());

        strategy.unsubscribers.push(subscription1, subscription2, subscription3);

        container.push(strategy);

        this.gridMode = 'Comparison';

        this._grid.api.setColumnDefs([]);

        const defs = getGridColumnDefinitions(this);

        this._grid.api.setColumnDefs(defs);

        this.sizeColumns();

        this.reselectLastSelectedCell();
    }


    private isWrongSide(targetSide: 'calls' | 'puts') {
        return targetSide !== 'calls' && targetSide !== 'puts';
    }

    @DetectMethodChanges({delay: 25})
    removeStrategy(targetSide: 'calls' | 'puts', str: PricingGridStrategy) {

        if (this.isWrongSide(targetSide)) {
            return;
        }

        const container = targetSide === 'calls' ? this.callStrategies : this.putStrategies;

        const ix = container.indexOf(str);

        if (ix === -1) {
            return;
        }

        str.unsubscribers.forEach(x => x.unsubscribe());

        container.splice(ix, 1);

        const removedColId = `pricing-${str.strategyId}-${targetSide === 'calls' ? 'call' : 'put'}`;
        this._userPricingColumnWidths.delete(removedColId);

        // CoPilot consistency rule (§8): if this was a CoPilot-loaded strategy, its border
        // and the card's Previewed state follow it out — WHATEVER removed it (Un-Preview,
        // re-Run cleanup, or the user's own strategy removal). No-ops for non-copilot ids.
        this.clearBorder(str.strategyId);
        this.opgCopilot?.onHostStrategyRemoved(str.strategyId);

        const defs = getGridColumnDefinitions(this);

        this.isLoading = true;

        this._grid.api.setColumnDefs([]);

        const codesToUnsubscribe = [];

        setTimeout(() => {
            try {

                this._grid.api.setColumnDefs(defs);

                this.sizeColumns();

                if (this.pricingRows.length > 0) {
                    this.pricingRows.forEach(x => {
                        const removedColumns = x.removeStrategyColumn(str, 'comparison');
                        removedColumns
                            .filter(col => !!col.strategyCode)
                            .forEach(col => {
                                codesToUnsubscribe.push(col.strategyCode);
                            });
                    });
                }


                this.changeOptionStrategiesSubscription(codesToUnsubscribe, []);

                this.pricingRows
                    .forEach(x => x.resetStrategyLegHighlights(targetSide, str))

            } finally {
                this.scrollToTargetSide(targetSide);
                this.isLoading = false;
                this.reselectLastSelectedCell();
            }

        }, 0);
    }

    @DetectMethodChanges()
    onStrategySomethingChanged(ev: PricingGridStrategy) {
        if (this._grid) {
            this._grid.api.refreshHeader();
            this.applyLiveIfPossible(ev.targetSide);
        }
    }

    private _refreshFlag = false;

    @DetectMethodChanges({isAsync: true})
    async onExpirationSelected(ev: { value: OptionExpirationDescriptor, previousValue?: OptionExpirationDescriptor, event: string }): Promise<void> {

        if (this._refreshFlag) {
            this._refreshFlag = false;
            return;
        }

        // WI-6 (CR-20260710-001) programmatic-nav echo guard. navigateToExpiration assigns
        // selectedExpiration then calls THIS method itself with event:'ets' to do the work; the
        // field assignment can ALSO echo back through the expiration-selector → dx-select-box →
        // onValueChanged ("does not always" fire — same uncertainty the restore belt-and-suspenders
        // notes). The echo carries the SAME value we just applied, so match it by value: let our own
        // 'ets' call through (staying armed), swallow one echo whose value equals the armed key, and
        // disarm on any other change so a missed echo can never eat a later USER selection.
        if (this._copilotNavEchoKey !== null) {
            const incomingKey = ev.value ? ev.value.optionExpirationDate : null;
            if (ev.event === 'ets' && incomingKey === this._copilotNavEchoKey) {
                // our authoritative navigation call — proceed, keep the guard armed for the echo
            } else if (incomingKey === this._copilotNavEchoKey) {
                this._copilotNavEchoKey = null;
                return;   // swallow the selector echo (one-shot)
            } else {
                this._copilotNavEchoKey = null;   // a different expiration superseded the nav
            }
        }

        // Unsubscribe from previous expiration's vertical skew before anything else.
        // ev.previousValue comes from DevExtreme's onValueChanged — holds the old expiration.
        if (ev.previousValue?.optionExpirationDate) {
            console.log(`[VerticalSkew] onExpirationSelected: prev=${ev.previousValue.optionExpirationDate} → new=${ev.value?.optionExpirationDate}`);
            this.unsubscribeSkewMeter(this.tradingInstrument?.ticker, ev.previousValue.optionExpirationDate);
        }

        if (isVoid(ev.value)) {
            await this.fillPricingRows();
            // CoPilot stale check (WI-15): the expiration was CLEARED — an early return, so the hook
            // at the tail of this method would never see it.
            this.opgCopilot?.onGridStateMaybeChanged();
            return;
        }

        console.timeLog('[OPG Restore]', `10. onExpirationSelected — exp=${ev.value?.optionExpirationDate}`);

        this.onCellClicked(null);

        this.pricingRows.forEach(x => x.resetCellHighlights());

        this._messageBus.publishAsync({
            topic: 'Opg.ExpirationChanged',
            payload: {
                component: this
            } as OpgExpirationChangeMessage
        });

        if (!isVoid(ev.value)) {
            this.saveOpgState('opg.expiration', ev.value.optionExpirationDate);
        }

        this.updateExpectedRangeDisplay();

        this.isLoading = true;

        console.timeLog('[OPG Restore]', '11. wrapInPromise (fillPricingRows / update rows) — start');
        await wrapInPromise(() => {
            try {

                if (this.pricingRows.length === 0) {
                    if (this.readyToFillPricingRows()) {
                        console.timeLog('[OPG Restore]', '12. fillPricingRows — start (from onExpirationSelected)');
                        return this.fillPricingRows();
                    }
                    console.timeLog('[OPG Restore]', '12. readyToFillPricingRows=false, skipping');
                    return;
                }

                this._rowsByStrategyCode = {};

                const alreadySubscribedTickers = this.getSubscribedTickers();
                const alreadySubscribedCodes = this.getSubscribedStrategyCodes();

                this.pricingRows.forEach(pr => {
                    pr.onExpirationChanged();
                });

                this._grid.api.applyTransactionAsync({update: this.pricingRows});

                const toSubscribeTickers = this.getSubscribedTickers();
                const toSubscribeCodes = this.getSubscribedStrategyCodes();

                this._lastQuoteCache.subscribeTickersDiff(alreadySubscribedTickers, toSubscribeTickers);

                this.changeOptionStrategiesSubscription(alreadySubscribedCodes, toSubscribeCodes);

                console.timeLog('[OPG Restore]', '12. updated existing rows + subscriptions');

            } finally {

                this.isLoading = false;

            }
        });

        this.impliedVolatility = null;
        this.fetchImpliedVolatility();
        this.subscribeSkewMeter();

        // CoPilot stale check (WI-15/A6): the panel's expiration is a fingerprint member, so ANY
        // change here may light the yellow. The CoPilot's OWN navigation (WI-6 preview) also lands
        // in this method — it re-baselines its expiration member synchronously inside
        // navigateToExpiration's caller, before this async tail runs, so by now the live value
        // already matches its baseline and this call correctly finds no drift. No-op on 'pmd'
        // (opgCopilot is null there) and before the first conversation exists.
        this.opgCopilot?.onGridStateMaybeChanged();
    }

    onGridReady(args: GridReadyEvent) {
        this._grid = args;
        this._grid.api.sizeColumnsToFit();

        console.time('[OPG Restore]');
        console.timeLog('[OPG Restore]', '1. onGridReady — starting applyOpgState()');
        this.applyOpgState().then(() => {
            console.timeLog('[OPG Restore]', '✓ applyOpgState() promise resolved');
        });

    }

    private reselectLastSelectedCell() {

        if (this.selectedCallCell) {
            this.onCellClicked(this.selectedCallCell);
        }

        if (this.selectedPutCell) {
            this.onCellClicked(this.selectedPutCell);
        }
    }

    onCellClicked(args: CellClickedEvent): void {

        this.isLoading = true;

        setTimeout(() => {

            try {

                if (isVoid(args)) {
                    this.selectedCallCell = this.selectedPutCell = undefined;
                    return;
                }

                const fieldCode = args.colDef.field;

                const isPricingColumn = fieldCode.startsWith('pricing-');

                let isHidingCell = true;

                const isCall = fieldCode.indexOf('-call') > 0;
                const isPut = fieldCode.indexOf('-put') > 0;

                if (isCall) {
                    const isOtm = isNullOrUndefined((args.data as PricingGridRow).callOtm);
                    isHidingCell = isOtm && !this.showItmData;
                    if (!isHidingCell && isPricingColumn) {
                        this.selectedCallCell = args;
                    }

                } else if (isPut) {
                    const isOtm = isNullOrUndefined((args.data as PricingGridRow).putOtm);
                    isHidingCell = isOtm && !this.showItmData;
                    if (!isHidingCell && isPricingColumn) {
                        this.selectedPutCell = args;
                    }
                }

                if (isHidingCell) {
                    if (fieldCode === 'rowStrike') {
                        this.selectedCallCell = undefined;
                        this.selectedPutCell = undefined;
                    } else {
                        if (fieldCode.indexOf('call') >= 0) {
                            this.selectedCallCell = undefined;
                        } else if (fieldCode.indexOf('put') >= 0) {
                            this.selectedPutCell = undefined;
                        }
                    }
                }

                let theCell = isCall ? this.selectedCallCell : this.selectedPutCell;

                if (this.showPnl) {

                    const isCallCellSelected = !isVoid(this.selectedCallCell);
                    const isPutCellSelected = !isVoid(this.selectedPutCell);

                    const callPnl0Column = this._grid.columnApi.getColumn('pnl-call-0');
                    const callPnl1Column = this._grid.columnApi.getColumn('pnl-call-1');
                    const putPnl0Column = this._grid.columnApi.getColumn('pnl-put-0');
                    const putPnl1Column = this._grid.columnApi.getColumn('pnl-put-1');

                    if (!isCallCellSelected) {
                        this._grid.columnApi.setColumnVisible(callPnl0Column, false);
                        this._grid.columnApi.setColumnVisible(callPnl1Column, false);
                    }

                    if (!isPutCellSelected) {
                        this._grid.columnApi.setColumnVisible(putPnl0Column, false);
                        this._grid.columnApi.setColumnVisible(putPnl1Column, false);
                    }

                    if (!isVoid(theCell)) {
                        const objAttribute = theCell.colDef.field.split('.')[0];

                        const strategy = this.callStrategies.concat(this.putStrategies)
                            .find(x => objAttribute.indexOf(x.strategyId) >= 0);

                        const isCalendarized = strategy?.isActuallyCalendarized;

                        if (isCall) {

                            this._grid.columnApi.setColumnVisible(callPnl0Column, true);

                            if (isCalendarized) {
                                this._grid.columnApi.setColumnVisible(callPnl1Column, true);
                            }

                            this._grid.columnApi.setColumnVisible(putPnl0Column, false);
                            this._grid.columnApi.setColumnVisible(putPnl1Column, false);

                        } else if (isPut) {

                            this._grid.columnApi.setColumnVisible(putPnl0Column, true);

                            if (isCalendarized) {
                                this._grid.columnApi.setColumnVisible(putPnl1Column, true);
                            }

                            this._grid.columnApi.setColumnVisible(callPnl0Column, false);
                            this._grid.columnApi.setColumnVisible(callPnl1Column, false);
                        }
                    }
                }

                this.toggleCombinedPnlColumns();

                this.pricingRows.forEach(row => row.resetCellHighlights());

                let callCellBaseRow: PricingGridRow;

                if (!isVoid(this.selectedCallCell)) {

                    const rowStrike = (this.selectedCallCell.data as PricingGridRow).rowStrike;

                    const baseRow = this.pricingRows
                        .find(row => row.rowStrike === rowStrike);

                    callCellBaseRow = baseRow;
                }

                let putCellBaseRow: PricingGridRow;

                if (!isVoid(this.selectedPutCell)) {

                    const rowStrike = (this.selectedPutCell.data as PricingGridRow).rowStrike;

                    const baseRow = this.pricingRows
                        .find(row => row.rowStrike === rowStrike);

                    putCellBaseRow = baseRow;
                }

                if (isVoid(callCellBaseRow) && isVoid(putCellBaseRow)) {
                    return;
                }

                if (callCellBaseRow === putCellBaseRow) {
                    callCellBaseRow.highlightStrategyLegs();
                } else {

                    if (callCellBaseRow) {
                        callCellBaseRow.highlightStrategyLegs();
                    }

                    if (putCellBaseRow) {
                        putCellBaseRow.highlightStrategyLegs();
                    }
                }

            } finally {

                this._messageBus.publish({
                    topic: 'Opg.CellSelected',
                    payload: {
                        component: this
                    } as OpgCellSelectedMessage
                })

                this._grid.api.refreshCells({force: true});

                this.isLoading = false;

            }
        });

    }

    private async onCopyToOtherPanel(args: GetContextMenuItemsParams, side: 'calls' | 'puts' | 'both') {
        const fieldCode = args.column.getColDef().field;

        if (fieldCode.startsWith('pricing-')) {

            this.copyEtsComboToClipboard(side, args);

        } else if (fieldCode === 'putPrice' || fieldCode === 'callPrice') {

            const gridRow = args.node.data as PricingGridRow;

            const isCall = fieldCode === 'callPrice';

            const isCombo = (isValidNumber(gridRow.putPriceQty, true) && !isCall)
                || (isValidNumber(gridRow.callPriceQty, true) && isCall);

            const colId = args.column.getColId();

            const is3col = colId.startsWith('trans')
                || colId.startsWith('own')
                || colId.startsWith('out');

            if (isCombo && !is3col) {
                this.copyEtsComboToClipboard(side, args);
            } else {
                this.copyEtsOptionContractToClipboard(args);
            }
        }
    }

    private async copyComboToTOS(args: GetContextMenuItemsParams, side: any) {

        const fieldCode = args.column.getColDef().field;

        if (fieldCode.startsWith('pricing-')) {

            await this.copyTOSComboToClipboard(args, side);

        } else if (fieldCode === 'putPrice' || fieldCode === 'callPrice') {

            const gridRow = args.node.data as PricingGridRow;

            const isCall = fieldCode === 'callPrice';

            const isCombo = (isValidNumber(gridRow.putPriceQty, true) && !isCall)
                || (isValidNumber(gridRow.callPriceQty, true) && isCall);

            if (isCombo) {
                await this.copyTOSComboToClipboard(args, side);
            } else {
                await this.copyTOSOptionContractToClipboard(args);
            }
        }
    }

    async onStrikesNumberChanged(ev): Promise<void> {
        if (!ev.event) {
            return;
        }

        this.saveOpgState('opg.num-of-strikes', ev.value);

        await this.fillPricingRows();
    }


    async onStrikeStepChanged(ev): Promise<void> {
        if (!ev.event) {
            return;
        }

        this.saveOpgState('opg.step', ev.value);

        await this.fillPricingRows();
    }


    async onCustomAtmStrikeChanged(ev): Promise<void> {
        // Guard: don't persist center-strike during symbol switches.
        // When switching underlyings, the strikes-dropdown emits strikeChanged(null)
        // during change detection. Persisting that null would overwrite the user's
        // saved center-strike for the incoming symbol.
        if (this._isSwitchingSymbol) {
            return;
        }

        this.centerStrike = ev.value;
        this.saveOpgState('opg.center-strike', this.centerStrike);
        await this.fillPricingRows();

        // CoPilot stale check (WI-15/A6): the chosen ATM is a fingerprint member (owner demo — the grid
        // went 7500 → 7525 while the "Chosen ATM · 7500" pill stayed put). This is the ONLY user-driven
        // writer of centerStrike; the silent writers (getStrikesToShow's market back-fill when it is
        // null, applyOpgState's restore) are settled by the CoPilot's pre-load baseline adoption, not by
        // a hook here. The CoPilot decides whether this drift is worth showing: it only counts while a
        // side's Price Range is on ATM Offset, the one form that reads the centre strike (owner).
        this.opgCopilot?.onGridStateMaybeChanged();
    }


    onShowItmDataChanged(ev) {

        this.isLoading = true;

        setTimeout(() => {

            try {

                if (!this.showItmData) {
                    if (this.selectedCallCell) {
                        if (this.isItmCell(this.selectedCallCell)) {
                            this.selectedCallCell = undefined;
                        }
                    }

                    if (this.selectedPutCell) {
                        if (this.isItmCell(this.selectedPutCell)) {
                            this.selectedPutCell = undefined;
                        }
                    }
                }

                const itmStrategyCodes = this.getItmStrategyCodes();

                if (this.showItmData) {
                    this.changeOptionStrategiesSubscription([], itmStrategyCodes);
                    console.log('subscribing itm data', itmStrategyCodes.length);
                } else {
                    this.changeOptionStrategiesSubscription(itmStrategyCodes, []);
                    console.log('un-subscribing itm data', itmStrategyCodes.length);
                }

                this.updateRowToStrategyIndex()

                this.makeHighlights().then(() => {

                    this.reselectLastSelectedCell();

                });

            } finally {

                this.isLoading = false;

            }
        });
    }

    onPricingModeChanged(ev) {
        if (this.pricingMode) {
            this._showItmDataBeforePricingMode = this.showItmData;
            if (!this.showItmData) {
                this.showItmData = true;
                this.onShowItmDataChanged(ev);
            }
        } else {
            if (this.showItmData !== this._showItmDataBeforePricingMode) {
                this.showItmData = this._showItmDataBeforePricingMode;
                this.onShowItmDataChanged(ev);
            }
        }

        this._grid?.api.refreshCells({force: true});
    }

    private getItmStrategyCodes(): string[] {
        const strategyCodes = this.pricingRows
            .flatMap(x =>
                x.getItmStrategyCodes()
            ).filter(x => !isNullOrUndefined(x));

        return strategyCodes;
    }

    isItmCell(selectedCell: CellClickedEvent): boolean {

        if (isVoid(selectedCell)) {
            return true;
        }

        if (!selectedCell.colDef.field) {
            return true;
        }

        if (!selectedCell.colDef.field.startsWith('pricing')) {
            return true;
        }

        if (!selectedCell.data) {
            return true;
        }

        const objAttributeName = selectedCell.colDef.field.split('.')[0];

        const data = selectedCell.data as PricingGridRow;

        const pricingCol = data[objAttributeName] as PricingGridStrategyColumn;

        if (!pricingCol) {
            return true;
        }

        if (pricingCol.optionType === OptionType.Call) {
            if (!isValidNumber(selectedCell.data.callOtm)) {
                return true;
            }
        }

        if (pricingCol.optionType === OptionType.Put) {
            if (!isValidNumber(selectedCell.data.putOtm)) {
                return true;
            }
        }
    }


    @DetectMethodChanges()
    showCustomColumnDialog() {
        this.customColumnDialogConfig.visible = true;
    }


    @DetectMethodChanges()
    onAddCustomColumnDialogClosed() {
        this.customColumnDialogConfig = {};
    }

    @DetectMethodChanges()
    private onStrategyApplyClicked(targetSide: 'calls' | 'puts', str: PricingGridStrategy) {

        if (!this._grid) {
            str.markForChanges();
            return;
        }

        if (!isValidNumber(this.defaultQty, true)) {
            this._toastr.error('Please Provide Default Qty');
            return;
        }

        if (this.mode === 'pmd') {
            try {
                this.validateHedges(targetSide);
            } catch {
                str.markForChanges();
                return;
            }
        }


        try {

            if (targetSide === 'calls') {
                this.selectedCallCell = undefined;
            } else if (targetSide === 'puts') {
                this.selectedPutCell = undefined;
            }

            const exists = this.pricingRows
                .some(x => x.getPricingColumnsAttributes().some(y => y.indexOf(str.strategyId) > 0));

            if (exists) {

                this.updateExistingStrategyColumns(str);

            } else {

                this.addStrategyColumn(targetSide, str);

            }
        } finally {

            str.afterLegsApplied();

            this._messageBus.publish({
                topic: 'Opg.StrategyApplied',
                payload: {
                    component: this
                }
            });

            setTimeout(() => this._grid?.api.refreshCells({force: true}), 500);
        }
    }

    @DetectMethodChanges({delay: 25})
    private addStrategyColumn(targeSide: 'calls' | 'puts', str: PricingGridStrategy) {

        this.isLoading = true;

        const newDefs = getGridColumnDefinitions(this);

        this._grid.api.setColumnDefs([]);

        setTimeout(() => {

            const codesToSubscribe: string[] = [];

            try {

                if (this.pricingRows.length > 0) {

                    this.pricingRows.forEach(pricingRow => {

                        const codeToSubscribe = pricingRow.addStrategyColumn(targeSide, str);

                        if (!isVoid(codeToSubscribe)) {
                            if (codesToSubscribe.indexOf(codeToSubscribe) === -1) {
                                codesToSubscribe.push(codeToSubscribe);
                            }
                        }
                    });
                }


                this._grid.api.setColumnDefs(newDefs);

                this.changeOptionStrategiesSubscription([], codesToSubscribe);

                this.sizeColumns();

            } finally {
                this.isLoading = false;
                this.scrollToTargetSide(targeSide);
            }

        }, 0);

    }


    @DetectMethodChanges({delay: 25})
    private updateExistingStrategyColumns(str: PricingGridStrategy) {

        this.isLoading = true;

        setTimeout(async () => {

            try {

                const alreadySubscribed = this.getSubscribedStrategyCodes();

                this.pricingRows.forEach(pricingRow => {
                    pricingRow.updateStrategyColumns(str);
                });

                const toSubscribe = this.getSubscribedStrategyCodes();

                this.changeOptionStrategiesSubscription(alreadySubscribed, toSubscribe);

                this._grid.api.refreshHeader();

                await this.makeHighlights();

            } finally {

                this.isLoading = false;

            }
        }, 0);
    }


    @DetectMethodChanges({isAsync: true})
    private async fillPricingRows(): Promise<void> {

        if (!this.numOfStrikes) {
            return;
        }

        this.selectedCallCell = this.selectedPutCell = undefined;

        this.isLoading = true;

        this._grid.api.setRowData([]);

        await wrapInPromise(() => {

            try {

                this._rowsByStrategyCode = {};

                const alreadySubscribedTickers = this.getSubscribedTickers();
                const alreadySubscribedCodes = this.getSubscribedStrategyCodes();

                console.timeLog('[OPG Restore]', '14. fillPricingRows — building rows');
                const strikes = this.getStrikesToShow();
                const rows = strikes.map(strike => new PricingGridRow(strike, this));

                rows.forEach((row: PricingGridRow) => {
                    row.setPricingColumns();

                });

                this.pricingRows = rows;

                const toSubscribeTickers = this.getSubscribedTickers();
                const toSubscribeCodes = this.getSubscribedStrategyCodes();

                // console.log('[-/+] change subscription (fillPricingRows)', [alreadySubscribedTickers, toSubscribeTickers]);

                this._lastQuoteCache.subscribeTickersDiff(alreadySubscribedTickers, toSubscribeTickers);

                this.changeOptionStrategiesSubscription(alreadySubscribedCodes, toSubscribeCodes);

                console.timeLog('[OPG Restore]', `15. fillPricingRows — setRowData (${rows.length} rows)`);
                this._grid.api.setRowData(rows);

                console.timeLog('[OPG Restore]', '✓ fillPricingRows — rows drawn');
                console.timeEnd('[OPG Restore]');

                this.makeHighlights().then(() => {
                });

            } finally {

                this.isLoading = false;

            }

        }, 0);
    }


    private readyToFillPricingRows(): boolean {
        return !!this.numOfStrikes &&
            !!this.selectedExpiration &&
            !!this.tradingInstrument;
    }


    @DetectMethodChanges({isAsync: true})
    private async setNewSymbol(symbol: TradingInstrument): Promise<void> {

        // CoPilot consistency rule (§8), part 1: no border may survive into the new symbol's
        // grid — clear immediately. The session reset itself happens at the END of this
        // method (after the new instrument + chain are assigned), so the fresh conversation
        // records the NEW ticker and the recreated questionnaire reads the NEW chain/ladder.
        //
        // (A6/WI-15 changed the WINDOW-CLOSE rule to a minimize — nothing is torn down there any more —
        // but NOT this one: a symbol change still resets the CoPilot, exactly as it always has. Owner
        // ruling 2026-07-14, on re-asking. A trade computed for SPX cannot be priced, previewed or even
        // sensibly displayed on an SPY ladder, so there is nothing worth preserving across the switch.)
        this.clearAllBorders();

        this._grid.api.setRowData([]);

        const lq = this._lastQuoteCache.subscribeTicker(symbol.ticker);

        if (lq) {
            this.lastPx = lq.lastPx;
        }

        this.unsubscribeCurrentTickers();

        const codesToUnsubscribe = this.getSubscribedStrategyCodes();
        this.changeOptionStrategiesSubscription(codesToUnsubscribe, []);

        this._rowsByStrategyCode = {};

        this.pricingRows = [];

        this.tradingInstrument = symbol;

        this.syncHorizontalSkew();

        const ticker = symbol.ticker;

        try {

            const chain = await this._optionsChainService.getChain(ticker);

            this.availableExpirations = chain.expirations.slice();

            this.dataStoreExpirations = chain.expirations.map(x => {
                const obj = {
                    expiration: x,
                    disabled: false
                };
                return obj;
            })

            console.debug(`Total expirations available: ${chain.expirations.length}`);

        } finally {
            this.isLoading = false;
        }

        // CoPilot consistency rule (§8), part 2: reset the advisory session AGAINST THE NEW
        // CONTEXT — tradingInstrument/availableExpirations are assigned above, so the child's
        // fresh conversation + recreated questionnaires read the new symbol's chain and
        // ladder (an earlier hook recorded the OLD ticker and left an open window offering
        // the previous chain's dates). No-ops when the CoPilot is absent/'pmd'.
        //
        // The fresh conversation captures its stale-grid baseline here, mid-restore, when the panel has
        // no expiration or centre strike yet — a PRE-LOAD baseline. applyOpgState's tail hook adopts the
        // restored values into it, so the switch itself never lights the yellow (WI-15).
        this.opgCopilot?.onSymbolChanged();
    }


    private getStrikesToShow(): number[] {

        if (isVoid(this.expiration)) {
            return [];
        }

        // Build arithmetic ladder centered on the user's chosen center strike.
        // The ladder is independent of the chain.
        let center = this.centerStrike;

        if (!isValidNumber(center, true)) {
            center = this.resolveMarketAtmStrike();
            this.centerStrike = center;
        }

        const strikes: number[] = [center];

        let cntr = 1;
        do {
            const nextStrike = center - cntr * this.strikeStep;
            strikes.unshift(nextStrike);
            cntr++;
        } while (strikes.length < this.numOfStrikes + 1 && cntr < 1000);

        cntr = 1;
        do {
            const nextStrike = center + cntr * this.strikeStep;
            strikes.push(nextStrike);
            cntr++;
        } while (strikes.length < this.numOfStrikes * 2 + 1 && cntr < 1000);

        return strikes;
    }

    private resolveMarketAtmStrike(): number {
        if (this.tradingInstrument) {
            const atm = this.atmStrikeService.getCurrentAtm(this.tradingInstrument.ticker);
            if (isValidNumber(atm, true)) {
                return atm;
            }
        }

        if (this.expiration && this.expiration.strikes.length > 0) {
            const midIx = Math.ceil(this.expiration.strikes.length / 2 - 1);
            return this.expiration.strikes[midIx];
        }

        return undefined;
    }

    private copyEtsOptionContractToClipboard(args: GetContextMenuItemsParams) {
        const fieldCode = args.column.getColDef().field;

        const gridRow = args.node.data as PricingGridRow;

        const optionType = fieldCode.indexOf('call') >= 0 ? OptionType.Call : OptionType.Put;

        const ticker = optionType === OptionType.Call ? gridRow.callTicker : gridRow.putTicker;

        const expStlye = isCashSettledOptionTicker(ticker) ? 'European' : 'American';

        const underlyingDisplayName = this._displayNameService.getDisplayNameForTicker(gridRow.gridSettings.expiration.underlyingTicker);
        const displayName = makeOptionDisplayName(gridRow.gridSettings.expiration, optionType, gridRow.rowStrike, expStlye, underlyingDisplayName);

        const item: ComboHighlightedItem = {
            accountId: null,
            comboId: null,
            portfolioId: null,
            ticker,
            underlying: gridRow.gridSettings.expiration.underlyingTicker,
            tickerDisplayName: displayName,
            netPosition: this.defaultQty,
            side: MarketSide.Buy,
            itemType: optionType === OptionType.Call ? PortfolioItemType.Call : PortfolioItemType.Put,
            strategyId: null,
        };

        const msg: ComboHighlightedUIMessage = {
            items: [item],
            orderParams: {
                orderLimitPx: (optionType === OptionType.Call ? gridRow.callPrice : gridRow.putPrice) * -1,
                orderDuration: TimeInForce.GTC,
                orderQty: 1,
                orderType: OrderType.Limit
            },
            strategyName: optionType === OptionType.Call ? 'Long Call' : 'Long Put',
        };

        this._clipboardService.put(ETS_CLIPBOARD_LEGS_KEY, msg);
        console.log(`[ETS-CLIPBOARD] write source=opg via=copyOptionToClipboard items=1`);
        this._toastr.success('Option copied to clipboard');
    }


    private copyEtsComboToClipboard(side: 'calls' | 'puts' | 'both', args: GetContextMenuItemsParams) {

        const messages: ComboHighlightedUIMessage[] = [];

        const ddd = (targetSide: any) => {

            const cb = this.makeComboItems(args, targetSide);

            const msg: ComboHighlightedUIMessage = {
                items: cb.items,
                orderParams: {
                    orderLimitPx: cb.orderPrice,
                    orderDuration: TimeInForce.GTC,
                    orderQty: 1,
                    orderType: OrderType.Limit
                },
            };

            if (this.mode === 'pmd') {
                const isCall = targetSide === 'calls';
                const groupId = isCall ? this.selectedCallHedge?.id : this.selectedPutHedge?.id;
                msg.hedgingGridTransaction = { groupId };
            }

            const valueGetter = args.column.getDefinition().headerValueGetter as Function;

            if (valueGetter) {
                try {
                    const name = valueGetter();
                    msg.strategyName = name;
                } catch {
                    //
                }
            }

            return msg;
        }

        if (side === 'calls' || side === 'both') {

            if (!isVoid(this.selectedCallCell)) {
                const msg = ddd('calls');
                messages.push(msg);
            }
        }

        if (side === 'puts' || side === 'both') {

            if (!isVoid(this.selectedPutCell)) {
                const msg = ddd('puts');
                messages.push(msg);
            }
        }

        if (messages.length === 0) {
            this._toastr.error('"Copy Orders" operation completed with errors');
            return
        }

        const universalPayload = messages.length === 1 ? messages[0] : messages;
        this._clipboardService.put(ETS_CLIPBOARD_LEGS_KEY, universalPayload);
        console.log(`[ETS-CLIPBOARD] write source=opg via=copyEtsComboToClipboard messages=${messages.length}`);
        this._toastr.success('Combo copied to clipboard');
    }

    private makeComboItems(args: GetContextMenuItemsParams, side: 'calls' | 'puts' | 'both'): {
        items: ComboHighlightedItem[],
        orderPrice: number,
        ledgerPrice: () => number
    } {

        let cell = undefined;

        if (side === 'calls') {
            cell = this.selectedCallCell;
        } else if (side === 'puts') {
            cell = this.selectedPutCell;
        }

        if (!cell) {
            this._toastr.error('Select Strategy Cell');
            return undefined;
        }

        const fieldCode = cell.column.getColDef().field;

        const columnName = fieldCode.split('.')[0];

        const gridRow = cell.node.data as PricingGridRow;

        const targetCell = gridRow[columnName] as PricingGridStrategyColumn;

        if (!targetCell) {
            console.error('Cannot find target cell');
            return;
        }

        // const optionType = columnName.indexOf('-call-') >= 0 ? OptionType.Call : OptionType.Put;
        if (isVoid(columnName)) {
            throw new Error('Bad Column Name');
        }

        const optionType = columnName.split('-').indexOf('call') >= 0 ? OptionType.Call : OptionType.Put;

        const legs = (this.mode === 'opg' ? targetCell.legs : targetCell.transLegs)
            .sort((a, b) => b.strike - a.strike);

        const comboItems = legs.map(x => {

            const expStyle = isCashSettledOptionTicker(x.ticker) ? 'European' : 'American';

            const optionTicker = parseOptionTicker(x.ticker);

            let expiration = this.optionChain.expirations
                .find(exp => exp.optionExpirationDate === optionTicker.expiration);

            const ulDisplayName = this._displayNameService.getDisplayNameForTicker(optionTicker.underlying);
            const displayName = makeOptionDisplayName(
                expiration,
                optionType,
                x.strike,
                expStyle,
                ulDisplayName
            );

            const item: ComboHighlightedItem = {
                accountId: null,
                comboId: null,
                portfolioId: null,
                ticker: x.ticker,
                underlying: gridRow.gridSettings.expiration.underlyingTicker,
                tickerDisplayName: displayName,
                netPosition: x.qty,
                side: x.side,
                itemType: optionType === OptionType.Call ? PortfolioItemType.Call : PortfolioItemType.Put,
                strategyId: null
            };

            return item;
        });

        const px = targetCell.price / targetCell.hcfMultiplier;

        return {
            items: comboItems,
            orderPrice: px,
            ledgerPrice: () => targetCell.price
        };
    }


    private getColumnDefinitions(): ColDef[] {
        if (!this._grid) {
            return [];
        }

        const colDefs = this._grid.api.getColumnDefs();

        const callsGroup: ColDef[] = (colDefs.find((cg: ColGroupDef) => cg.groupId === 'calls') || {} as any).children || [];
        const putsGroup: ColDef[] = (colDefs.find((cg: ColGroupDef) => cg.groupId === 'puts') || {} as any).children || [];

        const total = callsGroup.concat(putsGroup);
        return total;
    }


    @DetectMethodChanges()
    private async makeHighlights() {
        this.pricingRows.forEach(row => {
            row.resetCellHighlights();
            row.makeHighlights();
        });
        this._grid.api.refreshCells({force: true});
    }

    getLegColor(leg: PricingGridLegDescriptor): string {

        if (leg.side === 'Sell') {
            return 'color: red';
        }

        if (leg.side === 'Buy') {
            return 'color: cornflowerblue';
        }

        return undefined;

    }

    // covered by grid's cell style
    onRMultipleChanged(ev): void {

        this.isLoading = true;

        setTimeout(() => {
            try {

                this.pricingRows.forEach(row => row.highlightRMultiple());

            } finally {

                this._grid.api.refreshCells({force: true});
                this.isLoading = false;

            }
        }, 0);

    }

    // covered by grid's cell style
    onPercentProfitChanged(ev): void {

        this.isLoading = true;

        setTimeout(() => {
            try {

                this.pricingRows.forEach(row => row.highlightPercentageProfit());

            } finally {

                this._grid.api.refreshCells({force: true});
                this.isLoading = false;

            }
        }, 0);

    }

    onTargetRangeChanged(): void {

        this._messageBus.publishAsync({
            topic: 'Opg.TargetRangeChanged',
            payload: {
                component: this
            }
        });

        const cols2refresh = ['callPrice', 'putPrice'];

        this.isLoading = true;

        this.saveOpgState('opg.is-custom-range', this.isCustomRange);

        if (this.isCustomRange) {
            this.saveOpgState('opg.call-range-start', this.callsTargetRangeStart);
            this.saveOpgState('opg.call-range-end', this.callsTargetRangeEnd);
            this.saveOpgState('opg.put-range-start', this.putsTargetRangeStart);
            this.saveOpgState('opg.put-range-end', this.putsTargetRangeEnd);
        } else {
            this.saveOpgState('opg.call-offset', this.callOffset);
            this.saveOpgState('opg.call-range', this.callRange);
            this.saveOpgState('opg.put-offset', this.putOffset);
            this.saveOpgState('opg.put-range', this.putRange);
        }


        setTimeout(() => {
            try {

                this.pricingRows.forEach(row => row.highlightTargetRange());

            } finally {

                this._grid.api.refreshCells({columns: cols2refresh, force: true});
                this.isLoading = false;

            }

        }, 0);
    }

    private onQuote(quotes: QuoteDto[]) {
        if (!this.tradingInstrument) {
            return;
        }

        setTimeout(() => {
            const quote = quotes.find(q => q.ticker === this.tradingInstrument.ticker);
            if (quote) {
                this.lastPx = quote.lastPx;
                this._changeDetector.detectChanges();
            } else {
                if (this.bothSidesHasSelected()) { // to update total cost
                    this._changeDetector.detectChanges();
                }
            }
        });

        const updatedRows = [];

        this.pricingRows.forEach(row => {
            const isAffected = row.onQuote(quotes);
            if (isAffected) {
                updatedRows.push(row);
            }
        });

        this.pricingRows.forEach(row => row.highlightPayForIt());

        this._grid.api.applyTransactionAsync({update: updatedRows});
    }

    private onGreeks(x: GreeksDto): void {

        if (!this.tradingInstrument) {
            return;
        }

        const node: RowNode = this._grid.api.getRowNode(x.strike + '');

        if (!node) {
            return;
        }

        const line = node.data as PricingGridRow;

        if (!line) {
            return;
        }

        line.onGreeks(x);

        this._grid.api.applyTransactionAsync({update: [line]});
    }

    private getSubscribedTickers(): string[] {

        const tickers = this.pricingRows.flatMap(x => x.getTickers());

        const uq = Array.from(new Set(tickers));

        return uq;
    }

    private getSubscribedStrategyCodes(includeItm?: boolean): string[] {

        if (isVoid(includeItm)) {
            includeItm = this.showItmData;
        }

        const strategyCodes = this.pricingRows
            .flatMap(x =>
                x.getStrategyCodes(includeItm)
            ).filter(x => !isNullOrUndefined(x));

        return strategyCodes;
    }

    private changeOptionStrategiesSubscription(unsubscribe: string[], subscribe: string[]) {

        console.log('changeOptionStrategiesSubscription', unsubscribe, subscribe);

        this.updateRowToStrategyIndex();

        this._lastQuoteCache.subscribeStrategyCodesDiff(
            unsubscribe.filter(x => !isNullOrUndefined(x)),
            subscribe.filter(x => !isNullOrUndefined(x)));
    }

    private unsubscribeCurrentTickers() {
        const tickers = this.getSubscribedTickers();
        this._lastQuoteCache.unsubscribeTickers(tickers.filter(x => !isNullOrUndefined(x)));
    }

    private updateRowToStrategyIndex() {
        this.pricingRows.forEach(row => {
            const codes = row
                .getStrategyCodes()
                .filter(x => !isVoid(x));

            codes.forEach(code => this._rowsByStrategyCode[code] = row);
        });
    }

    private onStrategyPriceDto(messages: StrategyPriceDto[]): void {

        if (!this._grid) {
            return;
        }

        const rows = [];

        messages.forEach(x => {

            const row = this._rowsByStrategyCode[x.strategyCode];

            if (!row) {
                return;
            }

            const col = row.onStrategyPrice(x);

            if (!isVoid(col)) {
                rows.push(row);
            }

        });

        this._grid.api.applyTransactionAsync({update: rows});

    }

    protected getState(): PanelState {

        const state: PanelState = {
            isLinkedToSymbol: this.isLinkedToSymbol
        };

        return state;
    }


    protected setState(state: PanelState) {
        if (state) {
            this.isLinkedToSymbol = state.isLinkedToSymbol;
        }
    }

    @DetectMethodChanges({isAsync: true})
    async newTemplate(targetSide: 'calls' | 'puts') {

        if (this.isWrongSide(targetSide)) {
            return Promise.resolve();
        }

        let templateName: string;
        let isAssignable: boolean;

        try {
            const result = await this
                .editTemplatePopupModel.show('Save As Template');
            templateName = result.templateName;
            isAssignable = result.isAssignable;
        } catch {
            return;
        }

        const container = targetSide === 'calls' ? this.callStrategies : this.putStrategies;

        const pricingGridStrategyDescriptors = container.map(x => {
            const d = x.getDescriptor();
            d.strategyId = getShortUUID();
            return d;
        });

        const tpl = {
            templateName: templateName,
            templateId: getShortUUID(),
            underlying: this.tradingInstrument.ticker,
            descriptors: pricingGridStrategyDescriptors,
            isAssignable
        }

        try {
            await this._templatesService.save(tpl, targetSide);
            await this.onTemplateSelected(targetSide, {value: tpl, event: 'ets'})
            this._toastr.success(`Template saved!`);
        } catch (e) {
            console.log(e);
            this._toastr.error(e.message);
        }
    }


    @DetectMethodChanges({isAsync: true})
    async saveTemplate(targetSide: 'calls' | 'puts') {

        if (this.isWrongSide(targetSide)) {
            return Promise.resolve();
        }

        let tpl = targetSide === 'calls' ? this.callsSelectedTemplate : this.putsSelectedTemplate;

        if (isVoid(tpl)) {
            this._toastr.error('Template Not Selected');
            return Promise.resolve();
        }

        const container = targetSide === 'calls' ? this.callStrategies : this.putStrategies;

        const pricingGridStrategyDescriptors = container.map(x => x.getDescriptor());

        tpl.descriptors = pricingGridStrategyDescriptors;

        this.isLoading = true;

        try {
            await this._templatesService.save(tpl, targetSide);
            this._toastr.success(`Template saved!`);
        } catch (e) {
            console.error(e);
            this._toastr.error(`Template Not Saved`);
        } finally {
            this.isLoading = false;
        }
    }


    @DetectMethodChanges()
    toggleSidePanel(side: 'calls' | 'puts') {
        if (side === 'puts') {
            this.putsSidePanelVisible = !this.putsSidePanelVisible;
        } else if (side === 'calls') {
            this.callsSidePanelVisible = !this.callsSidePanelVisible;
        } else {
            return;
        }
    }

    getGridStrategies(targetSide: 'calls' | 'puts') {
        if (targetSide === 'calls') {
            return this.callStrategies;
        }

        if (targetSide === 'puts') {
            return this.putStrategies;
        }

        return [];
    }

    isSidePanelVisible(targetSide: 'calls' | 'puts') {
        if (targetSide === 'calls') {
            return this.callsSidePanelVisible;
        }

        if (targetSide === 'puts') {
            return this.putsSidePanelVisible;
        }

        return false;
    }

    canApplyAllStrategies(targetSide: 'calls' | 'puts'): boolean {
        if (this.isWrongSide(targetSide)) {
            return false;
        }

        if (targetSide === 'calls') {
            return this.callStrategies.length > 0 && this.callStrategies.some(x => x.canApplyLegs)
        } else {
            return this.putStrategies.length > 0 && this.putStrategies.some(x => x.canApplyLegs);
        }
    }

    applyAllStrategies(targetSide: 'calls' | 'puts') {

        if (this.isWrongSide(targetSide)) {
            return;
        }

        if (!isValidNumber(this.defaultQty, true)) {
            this._toastr.error('Please Provide Default Qty');
            return;
        }

        if (this.mode === 'pmd') {
            try {
                this.validateHedges(targetSide);
            } catch {
                return;
            }
        }

        if (targetSide === 'calls') {
            this.selectedCallCell = undefined;
        } else if (targetSide === 'puts') {
            this.selectedPutCell = undefined;
        }

        let ids = [];

        if (targetSide === 'calls') {
            this.callStrategies.forEach(x => {
                if (x.canApplyLegs) {
                    x.applyLegs();
                }
            });
            ids = this.callStrategies.map(x => x.strategyId);
        } else {
            this.putStrategies.forEach(x => {
                if (x.canApplyLegs) {
                    x.applyLegs();
                }
            });
            ids = this.putStrategies.map(x => x.strategyId);
        }

        setTimeout(() => {
            const side = targetSide === 'calls' ? 'call' : 'put';
            const colIds = ids.map(id => `pricing-${id}-${side}`);
            this.autoSizeNewPricingColumns(colIds);
        }, 500);
    }

    togglePropagateRange(calls: 'calls' | 'puts') {
        if (this.isWrongSide(calls)) {
            return;
        }

        this.onTargetRangeChanged();
    }

    @DetectMethodChanges({isAsync: true})
    async removeTemplate(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return;
        }

        const tpl = targetSide === 'calls' ? this.callsSelectedTemplate : this.putsSelectedTemplate;

        const text: string[] = [
            'Are you sure you want to delete',
            ` [${tpl.templateName}]`,
            ' template?'
        ]

        try {
            await this.confirmationDialogCmp.show(text);
        } catch {
            return;
        }

        this._templatesService.remove(tpl, targetSide);

        if (this.callsSelectedTemplate === tpl) {
            this.callsSelectedTemplate = null;
        }

        if (this.putsSelectedTemplate === tpl) {
            this.putsSelectedTemplate = null;
        }

        this._toastr.success('Template Removed!');

    }

    @DetectMethodChanges({isAsync: true})
    async editTemplate(targetSide: 'calls' | 'puts'): Promise<void> {

        if (this.isWrongSide(targetSide)) {
            return Promise.resolve();
        }

        const tpl = targetSide === 'calls' ? this.callsSelectedTemplate : this.putsSelectedTemplate;

        if (isVoid(tpl)) {
            return Promise.resolve();
        }


        try {
            const result = await this.editTemplatePopupModel.show('Edit Template', tpl);
            tpl.templateName = result?.templateName;
        } catch {
            return;
        }


        try {
            await this._templatesService.save(tpl, targetSide);

            setTimeout(() => {
                if (targetSide === 'calls') {
                    this.callsSelectedTemplate = null;
                } else {
                    this.putsSelectedTemplate = null;
                }

                this._changeDetector.detectChanges();
                this._toastr.success(`Template saved!`);
            });
        } catch (e) {
            console.error(e);
            this._toastr.error(e.message);
        }
    }

    canRemoveTemplate(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return false;
        }

        if (targetSide === 'calls') {
            return !isVoid(this.callsSelectedTemplate) && (!this.callsSelectedTemplate.isAssignable
                || this._sessionService.sessionData.isSuperUser);
        } else {
            return !isVoid(this.putsSelectedTemplate) && (!this.putsSelectedTemplate.isAssignable
                || this._sessionService.sessionData.isSuperUser);
        }
    }

    canRenameTemplate(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return false;
        }

        if (targetSide === 'calls') {
            return !isVoid(this.callsSelectedTemplate)
                && (!this.callsSelectedTemplate.isAssignable
                    || this._sessionService.sessionData.isSuperUser);
        } else {
            return !isVoid(this.putsSelectedTemplate)
                && (!this.putsSelectedTemplate.isAssignable
                    || this._sessionService.sessionData.isSuperUser);
        }
    }

    canSaveTemplate(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return false;
        }

        if (targetSide === 'calls') {
            return !isVoid(this.callsSelectedTemplate) && (!this.callsSelectedTemplate.isAssignable
                || this._sessionService.sessionData.isSuperUser);
        } else {
            return !isVoid(this.putsSelectedTemplate) && (!this.putsSelectedTemplate.isAssignable
                || this._sessionService.sessionData.isSuperUser);
        }
    }

    canNewTemplate(targetSide: 'calls' | 'puts') {
        if (this.isWrongSide(targetSide)) {
            return false;
        }

        if (targetSide === 'calls') {
            return !isVoid(this.callStrategies)
                && this.callStrategies.every(x => !isVoid(x.strategyLegs));
        } else {
            return !isVoid(this.putStrategies)
                && this.putStrategies.every(x => !isVoid(x.strategyLegs));
        }
    }

    /**
     * Repairs a broken grid layout without touching data. Re-applies the column
     * definitions from scratch and re-measures every pricing column.
     *
     * Layout-only by design (owner ruling 2026-09-01): strategies, templates and quote
     * subscriptions are left alone. This is NOT the Hedge Matrix rebuild -- HM's
     * reloads the book via onPortfolioSelected() and discards in-flight modifications.
     * Here the trader keeps everything they have loaded; only the rendering is rebuilt.
     *
     * Remembered manual column widths are dropped, because a bad manual drag is one of
     * the layouts this is meant to repair. After a rebuild every pricing column is
     * auto-sized to its content again.
     */
    @DetectMethodChanges()
    rebuildGrid() {
        if (!this._grid) {
            return;
        }

        this._userPricingColumnWidths.clear();

        this._grid.api.setColumnDefs([]);

        const defs = getGridColumnDefinitions(this);

        this._grid.api.setColumnDefs(defs);

        this.sizeColumns();

        this.reselectLastSelectedCell();

        this._toastr.success('Grid Rebuilt');
    }

    private sizeColumns() {
        if (!this._grid) {
            return;
        }

        const strategiesCount = this.callStrategies.length + this.putStrategies.length;

        if (strategiesCount < 4) {
            this._grid.api.sizeColumnsToFit();
        }

        this.autoSizeNewPricingColumns();
    }

    /**
     * Records a width the user set by dragging the column divider. Called only from
     * the grid's onColumnResized hook, and only for source === 'uiColumnDragged'.
     * A manual width recorded here survives every subsequent column-defs rebuild.
     */
    rememberUserColumnWidth(colId: string, width: number): void {
        if (!isValidNumber(width, true)) {
            return;
        }
        this._userPricingColumnWidths.set(colId, width);
    }

    private autoSizeNewPricingColumns(colIds?: string[]): void {
        if (!this._grid) {
            return;
        }

        if (!colIds) {
            const callColIds = this.callStrategies.map(s => `pricing-${s.strategyId}-call`);
            const putColIds = this.putStrategies.map(s => `pricing-${s.strategyId}-put`);
            colIds = [...callColIds, ...putColIds];
        }

        const allColumns = this._grid.columnApi.getAllColumns() || [];
        const columnsToAutoSize = [];

        for (const colId of colIds) {
            const col = allColumns.find(c => c.getColId() === colId);
            if (!col) {
                continue;
            }

            // A width the user set by dragging wins over auto-size, and keeps winning
            // across rebuilds. Anything else gets measured.
            const userWidth = this._userPricingColumnWidths.get(colId);
            if (userWidth !== undefined) {
                this._grid.columnApi.setColumnWidth(col, userWidth);
            } else {
                columnsToAutoSize.push(col);
            }
        }

        if (columnsToAutoSize.length === 0) {
            return;
        }

        // ag-Grid measures RENDERED body cells only. A pricing column outside the
        // horizontal viewport has its cells virtualized away, so autoSizeColumns falls
        // back to header text and clamps to minWidth. Both sides can be off-screen:
        // put columns sit at the right edge of the PUTS group, and calls scroll out as
        // soon as the viewport moves right. Every column is therefore brought into view
        // and measured in the same step.
        this.autoSizeRenderedColumns(columnsToAutoSize);
    }

    /**
     * Auto-sizes columns that may be outside the horizontal viewport. Each column is
     * brought into view (which forces ag-Grid to render its body cells) before being
     * measured. The original scroll position is restored when done.
     */
    private autoSizeRenderedColumns(columns: Column[]): void {

        // Remember where the user was looking, so the scrolling done below to force
        // rendering can be undone.
        const anchorColumn = this.getFirstRenderedColumn();

        // Each column is made visible and measured in the SAME step. Partitioning the
        // list into on-screen / off-screen up front does not work: scrolling to reach
        // one column virtualizes others out, so any column measured after a scroll
        // that moved away from it falls back to header text and clamps to minWidth.
        columns.forEach(col => {
            this._grid.api.ensureColumnVisible(col.getColId());
            this._grid.columnApi.autoSizeColumns([col]);
        });

        if (anchorColumn) {
            this._grid.api.ensureColumnVisible(anchorColumn.getColId());
        }
    }

    private getFirstRenderedColumn(): Column {
        const rendered = this._grid.columnApi.getAllDisplayedVirtualColumns() || [];
        return rendered.length > 0 ? rendered[0] : null;
    }

    private saveOpgState(key: OpgStateKey, value: any) {
        if (isVoid(this.tradingInstrument)) {
            return;
        }
        let storageKey = key as any;
        if (key !== 'opg.symbol') {
            storageKey = `${this.tradingInstrument.ticker}.${storageKey}`;
        }
        this._userSettingsService.setValue(storageKey, value);
    }

    private async applyOpgState(ti?: TradingInstrument) {
        let key: OpgStateKey = 'opg.symbol';

        if (isVoid(ti)) {
            const symbol = this._userSettingsService.getValue<string>(key);
            if (!isVoid(symbol)) {
                await this.onSymbolHighlightedMessage({ticker: symbol, source: 'Watchlist'});
            }

            return;
        }


        const ticker = ti.ticker;

        // Restore strikeStep, centerStrike, numOfStrikes BEFORE setting selectedExpiration,
        // because setting selectedExpiration triggers onExpirationSelected() via change detection,
        // which calls getStrikesToShow(). If centerStrike is still null at that point,
        // getStrikesToShow() overwrites it with the auto-calculated ATM.
        console.timeLog('[OPG Restore]', '8. restoring strikeStep, centerStrike, numOfStrikes, ranges');
        key = 'opg.step';
        let storageKey = `${ticker}.${key}`;
        const step = this._userSettingsService.getValue<number>(storageKey);
        const iStep = step; //parseInt(step);
        if (isValidNumber(iStep, true)) {
            this.strikeStep = iStep;
        } else {
            this.strikeStep = getStrikeStep(ti.ticker);
        }

        key = 'opg.center-strike';
        storageKey = `${ticker}.${key}`;
        const centerStrike = this._userSettingsService.getValue<number>(storageKey);
        const iCenterStrike = centerStrike;// parseInt(centerStrike);
        if (isValidNumber(iCenterStrike, true)) {
            this.centerStrike = iCenterStrike;
        } else {
            this.centerStrike = undefined;
        }

        key = 'opg.num-of-strikes';
        storageKey = `${ticker}.${key}`;
        const numOfStrikes = this._userSettingsService.getValue<number>(storageKey);
        const iNumOfStrikes = numOfStrikes;// parseInt(numOfStrikes);
        if (isValidNumber(iNumOfStrikes, true)) {
            this.numOfStrikes = iNumOfStrikes;
        } else {
            this.numOfStrikes = 25;
        }

        key = `opg.expiration`;
        storageKey = `${ticker}.${key}`;
        const expiration = this._userSettingsService.getValue(storageKey);
        if (!isVoid(expiration)) {
            let exp = this.availableExpirations.find(x => x.optionExpirationDate === expiration);
            if (isVoid(exp)) {
                exp = this.availableExpirations.filter(x => x.visible)[0];
            }
            console.timeLog('[OPG Restore]', `9. setting selectedExpiration=${exp?.optionExpirationDate} (stored=${expiration})`);
            this.selectedExpiration = exp;
        } else {
            const firstVisible = this.availableExpirations.filter(x => x.visible)[0];
            console.timeLog('[OPG Restore]', `9. setting selectedExpiration=${firstVisible?.optionExpirationDate} (no stored value)`);
            this.selectedExpiration = firstVisible;
        }


        let atmStrike = this.centerStrike;
        if (isVoid(atmStrike)) {
            atmStrike = this.atmStrikeService.getCurrentAtm(ti.ticker);
            console.timeLog('[OPG Restore]', `7. ATM strike from atmStrikeService=${atmStrike}`);
        }
        if (isVoid(atmStrike)) {
            const atmIx = findAtmStrikeIndex(this.selectedExpiration.strikes, null);
            atmStrike = this.selectedExpiration.strikes[atmIx];
            console.timeLog('[OPG Restore]', `7. ATM strike fallback (middle of strikes)=${atmStrike}`);
        }

        key = 'opg.call-range-start';
        storageKey = `${ticker}.${key}`;
        const callRangeStart = this._userSettingsService.getValue<number>(storageKey);
        const iCallRangeStart = callRangeStart;// parseInt(callRangeStart);
        if (isValidNumber(iCallRangeStart, true)) {
            this.callsTargetRangeStart = iCallRangeStart;
        } else {
            this.callsTargetRangeStart = atmStrike + (ticker === 'SPX' ? 50 : 5);
        }

        key = 'opg.call-range-end';
        storageKey = `${ticker}.${key}`;
        const callRangeEnd = this._userSettingsService.getValue<number>(storageKey);
        const iCallRangeEnd = callRangeEnd; //parseInt(callRangeEnd);
        if (isValidNumber(iCallRangeEnd, true)) {
            this.callsTargetRangeEnd = iCallRangeEnd;
        } else {
            this.callsTargetRangeEnd = this.callsTargetRangeStart + (ticker === 'SPX' ? 50 : 5);
        }

        key = 'opg.put-range-start';
        storageKey = `${ticker}.${key}`;
        const putRangeStart = this._userSettingsService.getValue<number>(storageKey);
        const iPutRangeStart = putRangeStart;// parseInt(putRangeStart);
        if (isValidNumber(iPutRangeStart, true)) {
            this.putsTargetRangeStart = iPutRangeStart;
        } else {
            this.putsTargetRangeStart = atmStrike - (ticker === 'SPX' ? 50 : 5);
        }

        key = 'opg.put-range-end';
        storageKey = `${ticker}.${key}`;
        const putRangeEnd = this._userSettingsService.getValue<number>(storageKey);
        const iPutRangeEnd = isValidNumber(putRangeEnd) ? putRangeEnd : null; // parseInt(putRangeEnd);
        if (isValidNumber(iPutRangeEnd, true)) {
            this.putsTargetRangeEnd = iPutRangeEnd;
        } else {
            this.putsTargetRangeEnd = this.putsTargetRangeStart - (ticker === 'SPX' ? 50 : 5);
        }

        key = 'opg.is-custom-range';
        storageKey = `${ticker}.${key}`;
        const isCustomRange = this._userSettingsService.getValue<boolean>(storageKey);
        const bIsCustomRange = isCustomRange || false; // isCustomRange === 'true';
        this.isCustomRange = bIsCustomRange;

        key = 'opg.call-offset';
        storageKey = `${ticker}.${key}`;
        const callOffset = this._userSettingsService.getValue<number>(storageKey);
        const iCallOffset = isValidNumber(callOffset) ? callOffset : null; // parseInt(callOffset) || null;
        this.callOffset = iCallOffset;

        key = 'opg.put-offset';
        storageKey = `${ticker}.${key}`;
        const putOffset = this._userSettingsService.getValue<number>(storageKey);
        const iPutOffset = isValidNumber(putOffset) ? putOffset : null; // parseInt(putOffset) || null;
        this.putOffset = iPutOffset;

        key = 'opg.call-range';
        storageKey = `${ticker}.${key}`;
        const callRange = this._userSettingsService.getValue<number>(storageKey);
        const iCallRange = isValidNumber(callRange) ? callRange : null; // parseInt(callRange) || null;
        this.callRange = iCallRange;

        key = 'opg.put-range';
        storageKey = `${ticker}.${key}`;
        const putRange = this._userSettingsService.getValue<number>(storageKey);
        const iPutRange = isValidNumber(putRange) ? putRange : null; // parseInt(putRange) || null;
        this.putRange = iPutRange;

        key = 'opg.default-qty.own';
        storageKey = `${ticker}.${key}`;
        const defaultQtyCustom = this._userSettingsService.getValue<number>(storageKey);
        const iDefaultQtyCustom = isValidNumber(defaultQtyCustom) ? defaultQtyCustom : null;// parseInt(defaultQtyCustom) || null;
        this.defaultQty = iDefaultQtyCustom;

        // Belt-and-suspenders: programmatic [(selectedExpiration)] assignment above
        // does not always cause DevExtreme to fire onValueChanged → onExpirationSelected,
        // which is the only other path that calls subscribeSkewMeter(). Without this
        // line, restore-after-login can leave the slot un-subscribed and badges stuck on N/A.
        this.subscribeSkewMeter();

        // CoPilot stale check (WI-15/A6) — the LAST word on a symbol switch. This method is the
        // SILENT writer of three fingerprint members (expiration, centerStrike, defaultQty: restored
        // from user settings, no change handler fires) and it runs AFTER setNewSymbol's hook, so
        // without this line the flag the CoPilot last pushed to the FAB would describe a half-restored
        // grid — mid-switch centerStrike is still null — and would then never be corrected, because
        // nothing else pokes. Re-checking here settles the indicator against the FINISHED restore.
        // No-op before the first conversation (and on 'pmd', where opgCopilot is null).
        this.opgCopilot?.onGridStateMaybeChanged();
    }

    private async copyTOSComboToClipboard(args: GetContextMenuItemsParams, side: any) {

        const cbItems = this.makeComboItems(args, side);

        if (isVoid(cbItems) || isVoid(cbItems.items)) {
            this._toastr.warning('No Legs to Copy!');
            return;
        }

        let hcf = 1;
        let orderQty = 1;

        const transformedLegs = cbItems.items
            .map(x => {

                const optionTicker = parseOptionTicker(x.ticker);

                const qty = (x.netPosition / hcf) * x.side;

                const date = DateTime.fromFormat(optionTicker.expiration, 'yyyy-MM-dd')
                    .toFormat('dd MMM yy')
                    .toUpperCase();

                const strike = optionTicker.strike;
                const type = optionTicker.type.toUpperCase();
                const price = cbItems.orderPrice;

                return {
                    qty,
                    date,
                    strike,
                    type,
                    price
                };
            });

        const underlying = cbItems.items[0].underlying;

        const quantities = transformedLegs.map(x => x.qty).join('/');
        const dates = transformedLegs.map(x => x.date).join('/');
        const strikes = transformedLegs.map(x => x.strike).join('/');
        const types = transformedLegs.map(x => x.type).join('/');
        const comboPrice = cbItems.orderPrice * -1;

        if (!isValidNumber(comboPrice)) {
            return undefined;
        }


        let line: string;
        if (underlying === 'SPX') {
            line = `BUY ${orderQty} ${quantities} CUSTOM ${underlying} 100 (Weeklys) ${dates} ${strikes} ${types} @ LMT GTC`;
        } else {
            line = `BUY ${orderQty} ${quantities} CUSTOM ${underlying} 100 ${dates} ${strikes} ${types} @ LMT GTC`;
        }

        await navigator.clipboard.writeText(line);

        this._toastr.success('Orders Copied to Clipboard!');
    }

    private async copyTOSOptionContractToClipboard(args: GetContextMenuItemsParams) {

        const fieldCode = args.column.getColDef().field;

        const gridRow = args.node.data as PricingGridRow;

        const optionType = fieldCode.indexOf('call') >= 0 ? OptionType.Call : OptionType.Put;

        const ticker = optionType === OptionType.Call ? gridRow.callTicker : gridRow.putTicker;

        const expStlye = isCashSettledOptionTicker(ticker) ? 'European' : 'American';

        const displayName = makeOptionDisplayName(gridRow.gridSettings.expiration, optionType, gridRow.rowStrike, expStlye);

        const underlying = gridRow.gridSettings.expiration.underlyingSymbol;

        const orderQty = 1;

        const quantities = this.defaultQty;

        const optionTicker = parseOptionTicker(ticker);

        const dates = DateTime.fromFormat(optionTicker.expiration, 'yyyy-MM-dd')
            .toFormat('dd MMM yy')
            .toUpperCase();

        const strikes = optionTicker.strike;

        const types = optionTicker.type.toUpperCase();

        let line: string;
        if (underlying === 'SPX') {
            line = `BUY ${orderQty} ${quantities} CUSTOM ${underlying} 100 (Weeklys) ${dates} ${strikes} ${types} @ LMT GTC`;
        } else {
            line = `BUY ${orderQty} ${quantities} CUSTOM ${underlying} 100 ${dates} ${strikes} ${types} @ LMT GTC`;
        }

        await navigator.clipboard.writeText(line);

        this._toastr.success('Order Copied to Clipboard!');
    }

    @DetectMethodChanges()
    onChange() {

    }

    private async initPortfolioService() {

        this.isLoading = true;

        try {

            const users = this._sessionService.sessionData.users
                .sort((a, b) => a.userName.localeCompare(b.userName));

            const grps = [];

            for (const user of users) {
                const grp = {
                    key: user.userName,
                    userId: user.userId,
                    items: []
                };

                const cfg: ServiceConfiguration = {
                    orientation: undefined,
                    userId: user.userId,
                    userName: user.userName
                };

                this._portfolioService.configure(cfg);

                // CR-20260928-001: every portfolio carries its own fixed asset; nothing to stamp.
                const pfs = this._portfolioService.getPortfolios();

                grp.items.push(...pfs);

                grps.push(grp);
            }

            const ownUser = this.getUserObject(this._sessionService.sessionData.userId);

            this._portfolioService.configure({
                orientation: undefined,
                userId: ownUser.userId,
                userName: ownUser.userName
            });

            const pfs = this._portfolioService.getPortfolios();

            const ownGrp = {
                key: ownUser.userName,
                userId: ownUser.userId,
                items: pfs
            }

            grps.unshift(ownGrp);

            this.portfolioList = grps;

        } finally {

            this.isLoading = false;

        }
    }

    private getUserObject(userId: string): UserDto {

        if (this._sessionService.sessionData.userId === userId) {

            const ownUserName = makeOwnDisplayName(this._sessionService.sessionData);

            return {
                userId,
                userName: ownUserName
            };

        } else {

            return this._sessionService.sessionData.users.find(x => x.userId === userId);
        }
    }

    getSelectedPortfolio(side: 'calls' | 'puts') {
        return side === "calls" ? this.selectedCallsPortfolio
            : this.selectedPutsPortfolio;
    }
    readPresetApgSource(side: 'calls' | 'puts'): string | null {
        const portfolio = this.getSelectedPortfolio(side);
        return portfolio ? JSON.stringify({ownerId: portfolio.userId, portfolioId: portfolio.id}) : null;
    }

    @DetectMethodChanges()
    onPortfolioSelecting(portfolio: ApgPortfolio, targetSide: 'calls' | 'puts') {
        if (targetSide === 'calls') {
            this.selectedCallsPortfolio = portfolio;
        } else {
            this.selectedPutsPortfolio = portfolio;
        }

        this._hedgesPricingService
            .subscribe(portfolio)
            .then(() => {
            });

        this._apgDataService.getPortfolioPositions(portfolio)
            .then(positions => {
                const soPos = positions
                    .flatMap(x => x).find(x => x.role === 'ShortOption');

                if (!soPos) {
                    this._toastr.warning('Unable to determine default quantity for selected portfolio. Your short options probably expired');
                    return;
                }

                const isExpired = this._optionsChainService.isOptionExpired(soPos.ticker);

                if (isExpired) {
                    this._toastr.warning('Some positions in this portfolio are expired');
                    return;
                }


                const qty = Math.abs(soPos.qty);

                if (!isValidNumber(qty, true)) {
                    this._toastr.warning('Unable to determine default quantity for selected portfolio. Your short options probably expired');
                    return;
                }

                this.defaultQty = qty;
            });

        setTimeout(() => {
            this.isLoading = true;
            this.updateHedges(portfolio, targetSide)
                .finally(() => {
                    this.isLoading = false;
                });
        });
    }

    private async updateHedges(portfolio: ApgPortfolio, targetSide: "calls" | "puts") {

        const hedgePositions = await this._hedgePositionService.getHedgePositions(portfolio);

        const type = targetSide === 'calls' ? 'Call' : 'Put';

        const hedgePositions1 = hedgePositions
            .filter(x => x.type === type)
            .filter(x => !this._optionsChainService.isOptionExpired(x.ticker));

        const hedgeGroups = Enumerable.from(hedgePositions1)
            .groupBy(x => x.groupId)
            .select(x => {
                return {
                    id: x.key(),
                    label: x.first()?.label,
                    items: x.toArray(),
                }
            })
            .toArray();

        if (targetSide === 'calls') {
            this.callHedgesList = hedgeGroups;
        } else {
            this.putHedgesList = hedgeGroups;
        }
    }

    getHedgesList(target: 'calls' | 'puts') {
        return target === "calls" ? this.callHedgesList
            : this.putHedgesList;
    }

    getSelectedHedge(targetSide: 'calls' | 'puts') {
        return targetSide === "calls" ? this.selectedCallHedge
            : this.selectedPutHedge;
    }

    @DetectMethodChanges()
    async onHedgeSelected(args: DxValueChanged<{ items: HedgePosition[] }>, targetSide: 'calls' | 'puts') {

        try {

            if (isVoid(args.event)) {
                return;
            }

            this.isLoading = true;

            const hedge = args.value;

            if (targetSide === 'calls') {
                if (this.selectedCallHedge === hedge) {
                    return;
                }
                this.selectedCallHedge = hedge as any;
            } else {
                if (this.selectedPutHedge === hedge) {
                    return;
                }
                this.selectedPutHedge = hedge as any;
            }

            if (isVoid(hedge)) {
                return;
            }

            if (hedge.items.length === 0) {
                return;
            }

            // Sync symbol if not selected
            if (isVoid(this.tradingInstrument)) {
                await this.onSymbolHighlightedMessage({ticker: hedge.items[0].asset, source: 'Watchlist'})
            }

            // Let's sync hedge expiration

            const hedgeItem = hedge.items[0];

            const chain = await this._optionsChainService.getChain(hedgeItem.asset);

            if (isVoid(chain)) {
                this._toastr.error('Unable to get option chains for selected underlying asset');
                return;
            }

            const expirationDate = this.selectedExpiration?.optionExpirationDate;

            if (expirationDate !== hedgeItem.expiration) {
                const exp = chain.expirations
                    .find(x => x.optionExpirationDate === hedgeItem.expiration);

                if (isVoid(exp)) {
                    this._toastr.error('Unable to get option chains for selected underlying asset');
                    return;
                }

                this.selectedExpiration = exp;
            }

            if (targetSide === 'calls') {
                this.callStrategies.forEach(x => x.markForChanges());
            } else if (targetSide === 'puts') {
                this.putStrategies.forEach(x => x.markForChanges());
            }

        } finally {

            this.isLoading = false;


            this.pricingRows.forEach(x => {
                x.getPricingColumnsAttributes().forEach(attr => {
                    (x[attr] as PricingGridStrategyColumn).resetPmdState();
                });
                x.resetCellHighlights();
                x.highlightOwnLegs(targetSide);
            });

            this._grid.api.refreshCells({force: true});

            this._messageBus.publish({
                topic: 'Pmd.HedgeSelected',
                payload: {
                    component: this
                }
            });
        }

    }

    customLegSideList: Array<any> = [
        {name: 'Buy', value: 1, color: 'cornflowerblue'},
        {name: 'Sell', value: -1, color: 'red'}
    ];

    customCallHedgeLegs: CustomHedgeLeg[] = [];

    customPutHedgeLegs: CustomHedgeLeg[] = [];

    getCustomLegs(targetSide: 'calls' | 'puts'): CustomHedgeLeg[] {
        if (targetSide === 'calls') {
            return this.customCallHedgeLegs
                .sort((a, b) => b?.strike - a?.strike);
        }
        if (targetSide === 'puts') {
            return this.customPutHedgeLegs
                .sort((a, b) => b?.strike - a?.strike);
        }
    }

    @DetectMethodChanges()
    addCustomLeg(targetSide: 'calls' | 'puts') {
        const leg = new CustomHedgeLeg(this._changeDetector,
            targetSide,
            this
        );

        leg.propertChanged$.subscribe(x => {

            if (targetSide === 'calls') {
                if (!this.customCallHedgeOffsetsAreFine) {
                    this._toastr.error('Selected Expiration Offset Cannot Be Applied');
                    return
                }
                this.callStrategies.forEach(x => x.markForChanges());
            } else if (targetSide === 'puts') {
                if (!this.customPutHedgeOffsetsAreFine) {
                    this._toastr.error('Selected Expiration Offset Cannot Be Applied');
                    return
                }
                this.putStrategies.forEach(x => x.markForChanges());
            }

            this.pricingRows.forEach(x => x.highlightOwnLegs(targetSide));
            this._grid.api.refreshCells({force: true});
        });

        if (targetSide === 'calls') {
            this.customCallHedgeLegs.push(leg);
            this.callStrategies.forEach(x => x.markForChanges());
        } else if (targetSide === 'puts') {
            this.customPutHedgeLegs.push(leg);
            this.putStrategies.forEach(x => x.markForChanges());
        }

        if (targetSide === 'calls') {
            this.selectedCallCell = undefined;
        } else if (targetSide === 'puts') {
            this.selectedPutCell = undefined;
        }

        this.pricingRows.forEach(x => {
            x.getPricingColumnsAttributes().forEach(attr => {
                (x[attr] as PricingGridStrategyColumn).resetPmdState();
            });
            x.resetCellHighlights();
            x.highlightOwnLegs();
        });

        this._grid.api.refreshCells({force: true});
    }

    getStyleForCustomLegSide(leg: CustomHedgeLeg) {
        return {
            style: `color: ${leg.side?.color}; text-align: center;`
        }
    }

    getExistingHedges(side: OptionType): HedgePosition[] {
        if (side === OptionType.Call) {
            if (!isVoid(this.selectedCallHedge)) {
                return this.selectedCallHedge.items;
            }
            if (!isVoid(this.customCallHedgeLegs)) {
                const legs = this.customCallHedgeLegs.map(x => x.asHedgePosition())
                    .filter(x => !isVoid(x));
                return legs;
            }
        } else if (side === OptionType.Put) {
            if (!isVoid(this.selectedPutHedge)) {
                return this.selectedPutHedge.items;
            }
            if (!isVoid(this.customPutHedgeLegs)) {
                const legs = this.customPutHedgeLegs.map(x => x.asHedgePosition())
                    .filter(x => !isVoid(x));
                return legs;
            }
        }
        return [];
    }

    pmdHedgeMode: 'custom' | 'existing' = 'existing';

    pmdCustomHedgeCalendarizedPut = false;

    pmdCustomHedgeCalendarizedCall = false;

    private validateHedges(side: 'calls' | 'puts') {

        if (side !== 'calls' && side !== 'puts') {
            throw Error();
        }

        const mode = this.pmdHedgeMode;

        if (mode === 'custom') {
            this.validateCustomHedges(side);
        } else {
            this.validateExistingHedges(side);
        }
    }

    private validateExistingHedges(side: "calls" | "puts") {
        if (side !== 'calls' && side !== 'puts') {
            throw Error();
        }

        const selectedHedge = side === 'calls' ? this.selectedCallHedge : this.selectedPutHedge;

        const positions = selectedHedge?.items;

        if (isVoid(positions)) {
            this._toastr.error('Please Select Valid Existing Hedge');
            throw new Error();
        }
    }

    private validateCustomHedges(side: 'calls' | 'puts') {

        if (side !== 'calls' && side !== 'puts') {
            throw Error();
        }

        const legs: CustomHedgeLeg[] = side === 'calls' ? this.customCallHedgeLegs : this.customPutHedgeLegs;

        if (isVoid(legs)) {
            this._toastr.error('Please Add Custom Hedge Legs');
            throw new Error();
        }

        const someBadLegs = legs.some(x =>
            isVoid(x.qty) || isVoid(x.side) || isVoid(x.strike)
        );

        if (someBadLegs) {
            this._toastr.error('Please, Fix Custom Hedge Legs Configuration');
            throw new Error();
        }
        return;
    }

    @DetectMethodChanges()
    removeCustomLeg(leg: CustomHedgeLeg, targetSide: 'calls' | 'puts') {

        const legs: CustomHedgeLeg[] = targetSide === 'calls' ? this.customCallHedgeLegs : this.customPutHedgeLegs;

        if (isVoid(legs)) {
            return;
        }

        try {

            if (isVoid(leg)) {
                legs.length = 0;
                return;
            }

            const ix = legs.indexOf(leg);

            if (ix < 0) {
                return;
            }

            legs.splice(ix, 1);

        } finally {

            if (targetSide === 'calls') {
                this.callStrategies.forEach(x => x.markForChanges());
            } else if (targetSide === 'puts') {
                this.putStrategies.forEach(x => x.markForChanges());
            }

            if (targetSide === 'calls') {
                this.selectedCallCell = undefined;
            } else if (targetSide === 'puts') {
                this.selectedPutCell = undefined;
            }


            this.pricingRows.forEach(x => {
                x.getPricingColumnsAttributes().forEach(attr => {
                    (x[attr] as PricingGridStrategyColumn).resetPmdState();
                });
                x.resetCellHighlights();
                x.highlightOwnLegs();
            });
            this._grid.api.refreshCells({force: true});
        }
    }

    private updateOwnHighlights(targetSide: 'calls' | 'puts' | undefined = undefined) {
        this.pricingRows.forEach(x => {
            x.highlightOwnLegs(targetSide);
        });
        this._grid.api.refreshCells({force: true});
    }

    getHedgesSectionTitle(side: 'calls' | 'puts'): string {
        if (side === 'calls') {
            return this.pmdHedgeMode === 'custom' ? 'Custom Call Hedge' : 'Your Call Hedges';
        }

        if (side === 'puts') {
            return this.pmdHedgeMode === 'custom' ? 'Custom Put Hedge' : 'Your Put Hedges';
        }

        return 'Hedges Section?';
    }

    @DetectMethodChanges()
    onChangeHedgesModeClicked(side: 'calls' | 'puts') {
        this.pmdCustomHedgeCalendarizedCall = false;
        this.pmdCustomHedgeCalendarizedPut = false;

        if (this.pmdHedgeMode === 'custom') {

            this.pmdHedgeMode = 'existing';

            this.customCallHedgeLegs = [];
            this.customPutHedgeLegs = [];

        } else {
            this.pmdHedgeMode = 'custom';

            this.selectedCallsPortfolio = undefined;
            this.selectedCallHedge = undefined;
            this.callHedgesList = [];

            this.selectedPutsPortfolio = undefined;
            this.selectedPutHedge = undefined;
            this.putHedgesList = [];
        }

        const key: OpgStateKey = this.pmdHedgeMode === 'existing' ? 'opg.default-qty.own' : 'opg.default-qty.custom';
        const storageKey = `${this.tradingInstrument?.ticker}.${key}`;
        const defaultQtyCustom = this._userSettingsService.getValue<number>(storageKey);
        const iDefaultQtyCustom = isValidNumber(defaultQtyCustom) ? defaultQtyCustom : null;// parseInt(defaultQtyCustom) || null;
        this.defaultQty = iDefaultQtyCustom;


        if (side === 'calls') {
            this.selectedCallCell = undefined;
        } else if (side === 'puts') {
            this.selectedPutCell = undefined;
        }


        this.pricingRows.forEach(x => {
            x.resetCellHighlights();
            x.highlightOwnLegs();
        });

        this._grid.api.refreshCells({force: true});
    }

    getPmdHedgeMode(targetSide: 'calls' | 'puts') {
        if (targetSide !== 'calls' && targetSide !== 'puts') {
            return '???';
        }

        return this.pmdHedgeMode;
    }

    canChangeUnderlying() {
        if (this.mode === 'opg') {
            return true;
        }

        return this.pmdHedgeMode !== 'existing';
    }

    canChangeExpiration() {
        if (this.mode === 'opg') {
            return true;
        }

        return this.pmdHedgeMode !== 'existing';
    }

    getHedgesCost(targetSide: 'calls' | 'puts'): number {
        if (targetSide !== 'calls' && targetSide !== 'puts') {
            return;
        }

        const groupId = targetSide === 'calls'
            ? this.selectedCallHedge?.id
            : this.selectedPutHedge?.id;

        if (isVoid(groupId)) {
            return undefined;
        }

        const cost = this._hedgesPricingService.getHedgeGroupCost(groupId);

        return cost;
    }

    @DetectMethodChanges()
    onDefaultQtyChanged($event: DxValueChanged<number>) {
        this.callStrategies.concat(this.putStrategies).forEach(x => x.markForChanges());

        const key: OpgStateKey = this.pmdHedgeMode === 'existing'
            ? 'opg.default-qty.own'
            : 'opg.default-qty.custom';

        this.saveOpgState(key, $event.value);

        this.applyLiveIfPossible();

        // CoPilot stale check (WI-15/A6): the default quantity is a fingerprint member (owner: "include
        // default qty"). It has no dedicated control inside the dialog, so its drift lights the refresh
        // button + the FAB only. NOTE an empty box is a REAL value (this underlying has no saved qty) —
        // typing the first quantity into it IS drift, and the CoPilot reports it as such.
        this.opgCopilot?.onGridStateMaybeChanged();
    }

    @DetectMethodChanges()
    onHedgingModeChanged($event: DxValueChanged<boolean>) {
        this.pricingRows.forEach(row => row.recalcPrices());
        this._grid?.api.refreshCells({force: true});
    }

    async copyOrders(destination: 'tos' | 'other-panel', args: GetContextMenuItemsParams, side: 'calls' | 'puts' | 'both') {

        this.showVerificationDialog(args, side)
            .then(async () => {
                if (destination === 'tos') {
                    await this.copyComboToTOS(args, side);
                } else if (destination === 'other-panel') {
                    await this.onCopyToOtherPanel(args, side);
                }
            })
            .catch(() => {
                // ignore
            });
    }

    bothSidesHasSelected(): boolean {
        return !isVoid(this.selectedCallCell) && !isVoid(this.selectedPutCell);
    }

    showVerificationDialog(args: GetContextMenuItemsParams, side: any): Promise<void> {
        const colId = args.column.getColId();
        const is3Col = colId.startsWith('trans') || colId.startsWith('own') || colId.startsWith('out');
        const isPrice = args.column.getColDef().field === 'callPrice' || args.column.getColDef().field === 'putPrice';

        if (is3Col || isPrice) {
            return Promise.resolve();
        }

        const configs: OrdersVerificationDialogConfig[] = [];

        if (side === 'calls' || side === 'both') {
            const combo = this.makeComboItems(args, 'calls');

            const config: OrdersVerificationDialogConfig = {
                orderLegs: combo.items,
                orderPrice: combo.orderPrice,
                ledgerPrice: combo.ledgerPrice,
                defaultQty: this.defaultQty
            };

            configs.push(config);
        }

        if (side === 'puts' || side === 'both') {
            const combo = this.makeComboItems(args, 'puts');

            const config: OrdersVerificationDialogConfig = {
                orderLegs: combo.items,
                orderPrice: combo.orderPrice,
                ledgerPrice: combo.ledgerPrice,
                defaultQty: this.defaultQty
            };

            configs.push(config);
        }

        return this.orderVerificationDialog.show(configs);
    }

    private applyLiveIfPossible(side?: 'calls' | 'puts') {

        const calls = this.canApplyAllStrategies('calls') && this.callsLiveMode;
        const puts = this.canApplyAllStrategies('puts') && this.putsLiveMode;

        switch (side) {
            case "calls":
                if (calls) {
                    this.applyAllStrategies('calls');
                }
                break;
            case "puts":
                if (puts) {
                    this.applyAllStrategies('puts');
                }
                break;
            default:
                if (calls) {
                    this.applyAllStrategies('calls');
                }

                if (puts) {
                    this.applyAllStrategies('puts');
                }
        }
    }


    @DetectMethodChanges({isAsync: true})
    private async onPortfoliosUpdated(payload: { portfolios: ApgPortfolio[] }) {
        const selectedCallPortfolioId = this.selectedCallsPortfolio?.id + this.selectedCallsPortfolio?.userId;
        const selectedPutPortfolioId = this.selectedPutsPortfolio?.id + this.selectedPutsPortfolio?.userId;

        const updatedCallSelected = payload.portfolios.find(x => {
            const key = x.id + x.userId;
            return key === selectedCallPortfolioId;
        });

        const updatedPutSelected = payload.portfolios.find(x => {
            const key = x.id + x.userId;
            return key === selectedPutPortfolioId;
        });

        try {
            this.isLoading = true;

            await this.initPortfolioService();

            if (updatedCallSelected) {
                this.selectedCallsPortfolio = updatedCallSelected;
            }

            if (updatedPutSelected) {
                this.selectedPutsPortfolio = updatedPutSelected;
            }

        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    scrollEvent$ = new EventEmitter<BodyScrollEvent>();

    onBodyScrollEvent(args: BodyScrollEvent) {
        // this.scrollEvent$.emit(args);
    }


    private scrollToTargetSide(targetSide: "calls" | "puts") {
        if (!this.autoScrollToTargetSide) {
            return;
        }

        const to = 0;

        if (targetSide === 'puts') {
            setTimeout(() => {
                this._grid.api.ensureColumnVisible('putOtm');
            }, to);
        } else if (targetSide === 'calls') {
            setTimeout(() => {
                this._grid.api.ensureColumnVisible('callOtm');
            }, to);
        }
    }


    findExpirationOffset(offset: number): OptionExpirationDescriptor {
        const result = findOffsetExpiration(
            this.selectedExpiration,
            offset,
            this.optionChain
        );

        return result;
    };

    @DetectMethodChanges()
    toggleCalendarized(strategy: PricingGridStrategy) {
        strategy.calendarized = !strategy.calendarized;
        if (!strategy.calendarized) {
            strategy.strategyLegs.forEach(x => x.expirationOffset = null);
        }
        strategy.onSomethingChanged();
    }

    isExpOffsetVisible(leg: PricingGridLegDescriptor, strategy: PricingGridStrategy): 'visible' | 'hidden' {
        if (leg.type === 'width') return 'hidden';
        return strategy.calendarized ? 'visible' : 'hidden';
    }

    private validateOffsetsForStrategies(validationContext: { side: string; expiration: OptionExpirationDescriptor }) {
        let callsAreGood = true;

        if (validationContext.side.toLowerCase().indexOf('call') >= 0) {
            callsAreGood = this.callStrategies.every(x => x.validateOffsets(validationContext));
        }

        let putsAreGood = true;

        if (validationContext.side.toLowerCase().indexOf('put') >= 0) {
            putsAreGood = this.putStrategies.every(x => x.validateOffsets(validationContext));
        }

        let allGood = true;

        if (validationContext.side.toLowerCase().indexOf('call') >= 0) {
            allGood = allGood && callsAreGood;
        }

        if (validationContext.side.toLowerCase().indexOf('put') >= 0) {
            allGood = allGood && putsAreGood;
        }

        return allGood;
    }


    @DetectMethodChanges()
    onExpirationListOpened() {

        this.dataStoreExpirations.forEach(exp => {

            const validationContext = {
                expiration: exp.expiration,
                side: 'Calls & Puts'
            };

            const offsetsGood = this.validateOffsetsForStrategies(validationContext);

            exp.disabled = !offsetsGood;
        });
    }

    async assignTemplates(targetSide: any) {
        const side = targetSide === 'calls' ? 'Call' : 'Put';
        await this.assignTemplatesDialog.show(side);
    }

    @DetectMethodChanges()
    toggleCalendarizedCustomHedge(targetSide: 'calls' | 'puts') {
        if (targetSide === 'calls') {
            this.pmdCustomHedgeCalendarizedCall = !this.pmdCustomHedgeCalendarizedCall;
            if (!this.pmdCustomHedgeCalendarizedCall) {
                this.customCallHedgeLegs.forEach(x => x.expirationOffset = undefined);
            }
        } else {
            this.pmdCustomHedgeCalendarizedPut = !this.pmdCustomHedgeCalendarizedPut;
            if (!this.pmdCustomHedgeCalendarizedPut) {
                this.customPutHedgeLegs.forEach(x => x.expirationOffset = undefined);
            }
        }
    }

    isPmdCustomHedgeCalendarized(targetSide: 'calls' | 'puts'): boolean {
        return targetSide === 'calls'
            ? this.pmdCustomHedgeCalendarizedCall
            : this.pmdCustomHedgeCalendarizedPut;
    }

    @DetectMethodChanges()
    copyStrategy(targetSide: 'calls' | 'puts', strategy: PricingGridStrategy) {
        const descriptor = strategy.getDescriptor();
        const copy = {targetSide, descriptor};
        this._clipboardService.put('opg.copy-strategy', copy);
        this._toastr.success(`Strategy "${strategy.strategyName}" has been copied to clipboard`);
    }

    canCopyStrategy(strategy: PricingGridStrategy) {
        return strategy.canApplyLegs || !strategy.isDirty;
    }

    canPasteStrategy() {
        return this._clipboardService.hasKey('opg.copy-strategy') ||
            this._clipboardService.hasKey(ETS_CLIPBOARD_LEGS_KEY);
    }

    async pasteStrategy(targetSide: 'calls' | 'puts') {
        const copy = this._clipboardService.get('opg.copy-strategy');

        if (!isVoid(copy)) {
            // Legacy 'opg.copy-strategy' path — unchanged.
            if (Array.isArray(copy)) {
                const sides = new Set<'calls' | 'puts'>();
                for (const entry of copy) {
                    const descriptor = entry.descriptor as PricingGridStrategyDescriptor;
                    descriptor.templateName = null;
                    descriptor.templateId = null;
                    descriptor.strategyId = getShortUUID();
                    descriptor.strategyName = `${descriptor.strategyName} Copy`;

                    await this.addStrategy(entry.targetSide, descriptor);
                    sides.add(entry.targetSide);
                }

                sides.forEach(side => this.applyLiveIfPossible(side));

                return;
            }

            if (isVoid(copy.descriptor)) {
                console.error('empty descriptor');
                this._toastr.error('Cannot paste strategy: clipboard data corrupted');
                return;
            }

            if (isVoid(copy.targetSide)) {
                console.error('empty target side');
                this._toastr.error('Cannot paste strategy: clipboard data corrupted');
                return;
            }

            const descriptor = copy.descriptor as PricingGridStrategyDescriptor;
            descriptor.templateName = null;
            descriptor.templateId = null;
            descriptor.strategyId = getShortUUID();
            descriptor.strategyName = `${descriptor.strategyName} Copy`;

            if (targetSide !== copy.targetSide) {
                descriptor.strategyLegs.reverse();
            }

            await this.addStrategy(targetSide, descriptor);

            this.applyLiveIfPossible(targetSide);
            return;
        }

        // FR-12 fallback: universal clipboard key (detailed legs from any source panel).
        const universal = this._clipboardService.get(ETS_CLIPBOARD_LEGS_KEY) as ComboHighlightedUIMessage | ComboHighlightedUIMessage[];
        if (isVoid(universal)) {
            console.error('empty clipboard data');
            this._toastr.error('Cannot paste strategy: clipboard data corrupted');
            return;
        }

        const messages = Array.isArray(universal) ? universal : [universal];
        const sides = new Set<'calls' | 'puts'>();

        for (const msg of messages) {
            if (!msg?.items?.length) continue;

            const sourceUnderlying = msg.items[0].underlying;
            if (this.tradingInstrument && this.tradingInstrument.ticker !== sourceUnderlying) {
                const sourceDisplay = this._tiService.getInstrumentByTicker(sourceUnderlying)?.displayName ?? sourceUnderlying;
                const targetDisplay = this.tradingInstrument.displayName ?? this.tradingInstrument.ticker;
                this._toastr.error(`Ticker mismatch: clipboard=${sourceDisplay} target=${targetDisplay}. Paste refused.`);
                console.log('[ETS-CLIPBOARD] paste rejected target=opg reason=ticker-mismatch');
                return;
            }

            const expirations = new Set(msg.items.map(i => parseOptionTicker(i.ticker)?.expiration).filter(x => !!x));

            // CR-20260917-002 (owner smoke 2026-09-17): the paste FOLLOWS the source's expiration,
            // as the ORION preview does — otherwise the structure lands on whatever date the grid
            // happened to show and prices a different trade. Front expiration = the earliest leg;
            // a multi-expiration source then maps its other legs as offsets from it (FR-23 below).
            // The switch is the same seam the ORION uses (`navigateToExpiration`), so a date the
            // grid cannot show refuses the paste instead of silently keeping the old one.
            const frontExpiration = Array.from(expirations).sort()[0];
            if (frontExpiration && !this.navigateToExpiration(frontExpiration)) {
                this._toastr.error(`Expiration ${frontExpiration} is not available in OPG. Paste refused.`);
                console.log(`[ETS-CLIPBOARD] paste rejected target=opg reason=exp-not-available exp=${frontExpiration}`);
                return;
            }

            // CR-20260917-002 (owner smoke 2026-09-17): the pasted quantity is the source's EFFECTIVE
            // quantity divided by the grid's Default Qty — 20 contracts on a Default Qty of 10 paste
            // as 2, so the OPG prices the same trade Maven priced (both show per-default-qty prices).
            // A quantity that is not a whole multiple of Default Qty (or no usable Default Qty at
            // all) is NOT refused and NOT reduced to a common denominator: the grid's Default Qty
            // itself drops to 1 and the legs paste at their raw quantity — the ORION's way (owner
            // ruling 2026-09-17, replacing round 2's refusal). Same recipe as navigateToExpiration:
            // the box two-way-binds the field, so assign it FIRST, then drive its handler ourselves
            // so the state save, the strategies' re-mark, the live apply and the ORION stale check
            // all run as if typed. This replaces the HCF unit-pattern rule for every source.
            const qtyUsable = isValidNumber(this.defaultQty, true) && this.defaultQty > 0;
            const offQty = qtyUsable ? msg.items.find(i => Math.abs(i.netPosition ?? 0) % this.defaultQty !== 0) : undefined;
            if (!qtyUsable || offQty) {
                const previousQty = this.defaultQty;
                this.defaultQty = 1;
                this.onDefaultQtyChanged({value: 1, previousValue: previousQty, event: 'ets'});
                const why = offQty
                    ? `pasted quantity ${Math.abs(offQty.netPosition)} is not a multiple of ${previousQty}`
                    : 'no Default Qty was set';
                this._toastr.warning(`Default Qty set to 1: ${why}`);
                console.log(`[ETS-CLIPBOARD] target=opg default-qty-reset-to-1 previous=${previousQty} qty=${offQty?.netPosition}`);
            }

            if (expirations.size > 1) {
                if (!this.selectedExpiration) {
                    this._toastr.error('Select an expiration in OPG before pasting multi-expiration strategy');
                    console.log('[ETS-CLIPBOARD] paste rejected target=opg reason=multi-exp-no-selected');
                    return;
                }
                // FR-23: multi-expiration paste maps each leg to expirationOffset relative
                // to OPG selected expiration. Pre-validate that every distinct exp is
                // representable as an offset; reject early if any falls outside scan range.
                const expArr = Array.from(expirations);
                for (const exp of expArr) {
                    const offset = this._computeExpirationOffset(exp);
                    if (offset === null) {
                        this._toastr.error(`Cannot map expiration ${exp} to offset relative to OPG selected expiration. Paste refused.`);
                        console.log(`[ETS-CLIPBOARD] paste rejected target=opg reason=exp-out-of-offset-range exp=${exp}`);
                        return;
                    }
                }
            }

            // Split items by Call/Put to handle double-sided strategies in a single message.
            const callItems = msg.items.filter(i => parseOptionTicker(i.ticker)?.type === 'Call');
            const putItems = msg.items.filter(i => parseOptionTicker(i.ticker)?.type === 'Put');
            const isDouble = callItems.length > 0 && putItems.length > 0;

            if (isDouble) {
                // Double-sided source: route Call legs to CALLS bucket, Put legs to PUTS
                // bucket. User's clicked targetSide is ignored — both sides paste.
                const callDescriptor = this._buildOpgDescriptorFromItems(callItems);
                const putDescriptor = this._buildOpgDescriptorFromItems(putItems);

                if (callDescriptor) {
                    await this.addStrategy('calls', callDescriptor);
                    this.setBorder(callDescriptor.strategyId, 'calls', this._pastedStartingStrike(callItems, 'calls'));
                    sides.add('calls');
                }
                if (putDescriptor) {
                    await this.addStrategy('puts', putDescriptor);
                    this.setBorder(putDescriptor.strategyId, 'puts', this._pastedStartingStrike(putItems, 'puts'));
                    sides.add('puts');
                }
            } else {
                // Single-sided source.
                const sourceSide: 'calls' | 'puts' = callItems.length > 0 ? 'calls' : 'puts';
                const descriptor = this._buildOpgDescriptorFromItems(msg.items);
                if (!descriptor) {
                    this._toastr.error('Could not build template from clipboard items');
                    continue;
                }

                // If user pasted into opposite-type bucket, reverse legs.
                // Mirrors legacy 'opg.copy-strategy' path at :3977-3979.
                if (sourceSide !== targetSide) {
                    descriptor.strategyLegs.reverse();
                }

                await this.addStrategy(targetSide, descriptor);
                this.setBorder(descriptor.strategyId, targetSide, this._pastedStartingStrike(msg.items, targetSide));
                sides.add(targetSide);
            }
        }

        sides.forEach(side => this.applyLiveIfPossible(side));

        console.log(`[ETS-CLIPBOARD] read target=opg via=universal-key messages=${messages.length}`);
        this._toastr.success('Strategy pasted');
    }

    private _buildOpgLegsFromComboItems(items: ComboHighlightedItem[]): PricingGridLegDescriptor[] {
        // OPG sidebar template renders descriptor array directly top-down
        // (array[0] = top of display). Universal visual rule: top = highest strike.
        // Sort DESC by strike for both Calls and Puts.
        const enriched = items
            .map(i => {
                const parsed = parseOptionTicker(i.ticker);
                return { strike: parsed?.strike, expiration: parsed?.expiration, side: i.side, qty: i.netPosition };
            })
            .filter(x => x.strike != null)
            .sort((a, b) => b.strike - a.strike);

        // CR-20260917-002 (owner ruling 2026-09-17): template qty = effective qty / the grid's
        // Default Qty, so the OPG prices the trade the source priced (20 on a default of 10 → 2).
        // Replaced the HCF unit-pattern division (10-20-20 → 1-2-2), which lost the scale.
        // The caller has already dropped Default Qty to 1 when any qty is not a whole multiple of it.
        const divisor = this.defaultQty;

        // Per-leg expiration offset (FR-23): compute offset relative to OPG selected
        // expiration. Single-exp source → all offsets 0 (left undefined). Multi-exp →
        // each leg gets numeric offset matching findOffsetExpiration semantics.
        const uniqueExps = new Set(enriched.map(x => x.expiration).filter(x => !!x));
        const isMultiExp = uniqueExps.size > 1;

        const opgLegs: PricingGridLegDescriptor[] = [];
        enriched.forEach((item, index) => {
            if (index > 0) {
                const prevStrike = enriched[index - 1].strike;
                const width = Math.abs(prevStrike - item.strike);
                opgLegs.push({ type: 'width', width });
            }
            const sideStr: 'Buy' | 'Sell' = item.side === MarketSide.Buy ? 'Buy' : 'Sell';
            const leg: PricingGridLegDescriptor = {
                type: 'leg',
                side: sideStr,
                qty: Math.abs(item.qty) / divisor,
            };
            if (isMultiExp && item.expiration) {
                const offset = this._computeExpirationOffset(item.expiration);
                if (offset !== null && offset !== 0) {
                    leg.expirationOffset = offset;
                }
            }
            opgLegs.push(leg);
        });
        return opgLegs;
    }

    private _computeExpirationOffset(sourceExpDate: string): number | null {
        if (!this.selectedExpiration || !this.optionChain) {
            console.log(`[ETS-CLIPBOARD] offset compute target=opg result=null reason=no-selected-or-chain selected=${!!this.selectedExpiration} chain=${!!this.optionChain}`);
            return null;
        }
        if (this.selectedExpiration.optionExpirationDate === sourceExpDate) return 0;

        // Inversion: scan integer offsets ±60 (covers typical chain depth) and find
        // the value where findOffsetExpiration yields a descriptor whose
        // optionExpirationDate matches sourceExpDate.
        const range = 60;
        const sourceAfter = sourceExpDate > this.selectedExpiration.optionExpirationDate;
        const start = sourceAfter ? 1 : -1;
        const end = sourceAfter ? range : -range;
        const step = sourceAfter ? 1 : -1;
        for (let i = start; sourceAfter ? i <= end : i >= end; i += step) {
            const found = findOffsetExpiration(this.selectedExpiration, i, this.optionChain);
            if (found?.optionExpirationDate === sourceExpDate) {
                console.log(`[ETS-CLIPBOARD] offset compute target=opg src=${sourceExpDate} selected=${this.selectedExpiration.optionExpirationDate} result=${i}`);
                return i;
            }
        }
        console.log(`[ETS-CLIPBOARD] offset compute target=opg src=${sourceExpDate} selected=${this.selectedExpiration.optionExpirationDate} result=null reason=no-match-in-range`);
        return null;
    }

    // CR-20260917-002 (owner smoke 2026-09-17): a pasted strategy's column prices on every row — a
    // wall of strikes — and the trader had to hunt for where the hedge actually starts. Mark its
    // starting strike with the ORION preview's own "X marks the spot" border (setBorder). The
    // start is the row the column anchors the pattern at: a CALLS column walks UP from its row, so
    // the start is the LOWEST leg strike; a PUTS column walks DOWN, so the HIGHEST (loadTrade's
    // contract). Keyed on the side the strategy LANDS on — a cross-side paste reverses the legs,
    // and the anchor follows the column. The border clears with the strategy (removeStrategy).
    private _pastedStartingStrike(items: ComboHighlightedItem[], side: 'calls' | 'puts'): number {
        const strikes = items.map(i => parseOptionTicker(i.ticker)?.strike).filter(s => isValidNumber(s));
        return side === 'calls' ? Math.min(...strikes) : Math.max(...strikes);
    }

    private _buildOpgDescriptorFromItems(items: ComboHighlightedItem[]): PricingGridStrategyDescriptor | undefined {
        if (!items?.length) return undefined;

        const opgLegs = this._buildOpgLegsFromComboItems(items);
        if (opgLegs.length === 0) return undefined;

        const legCount = items.length;
        let selectedStrategy: any;
        switch (legCount) {
            case 1: selectedStrategy = '1 Leg'; break;
            case 2: selectedStrategy = '2 Legs'; break;
            case 3: selectedStrategy = '3 Legs'; break;
            case 4: selectedStrategy = '4 Legs'; break;
            case 5: selectedStrategy = '5 Legs'; break;
            case 6: selectedStrategy = '6 Legs'; break;
            case 7: selectedStrategy = '7 Legs'; break;
            case 8: selectedStrategy = '8 Legs'; break;
            default: selectedStrategy = `${legCount} Legs`; break;
        }

        const strikes = items.map(i => parseOptionTicker(i.ticker)?.strike).filter(s => s != null);
        const width = strikes.length >= 2 ? Math.abs(strikes[0] - strikes[1]) : 5;

        return {
            strategyId: getShortUUID(),
            selectedStrategy,
            strategyLegs: opgLegs,
            strategyName: '[Paste From Clipboard]',
            width,
        } as PricingGridStrategyDescriptor;
    }

    getCurrentAtm() {
        if (isVoid(this.tradingInstrument)) {
            return undefined;
        }

        const ticker = this.tradingInstrument.ticker;

        const currentAtm = this.atmStrikeService.getCurrentAtm(ticker);

        return currentAtm;
    }

    getPnlColumnHeader(colId: string) {

        if (isVoid(colId)) {
            return 'N/A';
        }

        if (colId.indexOf('-call') > 0) {

            if (isVoid(this.selectedCallCell)) {
                return 'N/A';
            }

            const offsets = Enumerable.from(this.callStrategies)
                .selectMany(x => x.strategyLegs)
                .select(x => x.expirationOffset || 0)
                .distinct()
                .orderBy(x => x)
                .toArray()

            const colOffset = parseInt(colId.split('-')[2]);

            const optionExpirationDisplayDate = this.findExpirationOffset(offsets[colOffset])?.optionExpirationDisplayDate;

            return optionExpirationDisplayDate;

        } else if (colId.indexOf('-put-') > 0) {

            if (isVoid(this.selectedPutCell)) {
                return 'N/A';
            }

            const offsets = Enumerable.from(this.putStrategies)
                .selectMany(x => x.strategyLegs)
                .select(x => x.expirationOffset || 0)
                .distinct()
                .orderBy(x => x)
                .toArray()

            const colOffset = parseInt(colId.split('-')[2]);

            const optionExpirationDisplayDate = this.findExpirationOffset(offsets[colOffset])?.optionExpirationDisplayDate;

            return optionExpirationDisplayDate;
        } else {
            return 'N/A';
        }
    }


    getTotalPnlColumnHeader(colId: string) {

        if (isVoid(colId)) {
            return 'N/A';
        }

        const offsets = Enumerable.from(this.callStrategies)
            .concat(this.putStrategies)
            .selectMany(x => x.strategyLegs)
            .select(x => x.expirationOffset || 0)
            .distinct()
            .orderBy(x => x)
            .toArray();

        const colOffset = parseInt(colId.split('-')[1]);

        const optionExpirationDisplayDate = this.findExpirationOffset(offsets[colOffset])?.optionExpirationDisplayDate;

        return optionExpirationDisplayDate || 'N/A';
    }


    onShowPnlChanged($event: DxValueChanged<boolean>) {
        if (isVoid($event.event)) {
            return;
        }

        if (!$event.value) {

            this._grid.columnApi
                .setColumnsVisible(['pnl-call-0', 'pnl-put-0', 'pnl-call-1', 'pnl-put-1'], false);

        } else {
            if (!isVoid(this.selectedCallCell)) {
                this.onCellClicked(this.selectedCallCell);
            }

            if (!isVoid(this.selectedPutCell)) {
                this.onCellClicked(this.selectedPutCell);
            }
        }
    }

    @DetectMethodChanges()
    onShowPnl2Changed($event: DxValueChanged<boolean>) {
        this.toggleCombinedPnlColumns();
    }

    private toggleCombinedPnlColumns() {
        if (!this.showPnl2) {
            this._grid.columnApi.setColumnsVisible([
                'totalPnl-0',
                'totalPnl-1',
                'strikeColumn2'
            ], false);
        } else {
            const anySelected = !isVoid(this.selectedCallCell)
                || !isVoid(this.selectedPutCell);

            const keys = ['totalPnl-0', 'strikeColumn2'];

            const anyStrategyCalendarized = this.isAnyStrategyCalendarized();

            if (anyStrategyCalendarized) {
                keys.push('totalPnl-1');
            }

            this._grid.columnApi.setColumnsVisible(keys, anySelected);

        }

        this.gridApi.sizeColumnsToFit();
    }

    private isSelectedStrategyCalendarized(theCell: CellClickedEvent) {

        if (isVoid(theCell)) {
            return false;
        }

        const objAttribute = theCell.colDef.field.split('.')[0];

        const strategy = this.callStrategies.concat(this.putStrategies)
            .find(x => objAttribute.indexOf(x.strategyId) >= 0);

        const isCalendarized = strategy?.isActuallyCalendarized;

        return isCalendarized;
    }

    isAnyStrategyCalendarized() {
        return this.isSelectedStrategyCalendarized(this.selectedCallCell)
            || this.isSelectedStrategyCalendarized(this.selectedPutCell);
    }

    getTotalCost() {

        const callCost = !isVoid(this.selectedCallCell)
            ? this._grid.api.getValue(this.selectedCallCell.colDef.colId, this.selectedCallCell.node)
            : undefined;

        const putCost = !isVoid(this.selectedPutCell)
            ? this._grid.api.getValue(this.selectedPutCell.colDef.colId, this.selectedPutCell.node)
            : undefined;

        if (!isValidNumber(callCost) || !isValidNumber(putCost)) {
            return undefined;
        }

        return callCost + putCost;
    }

    getTotalCostCssClasses() {
        const totalCost = this.getTotalCost();
        const css = ['total-cost'];
        if (totalCost > 0) {
            css.push('ets-positive-number');
        } else if (totalCost < 0) {
            css.push('ets-negative-number');
        }
        return css;
    }


    //


    getExpirationOffset(leg: PricingGridLegDescriptor | CustomHedgeLeg) {
        const isValid = isValidNumber(leg.expirationOffset, true);

        if (!isValid) {
            return '';
        }

        if (leg.expirationOffset < 0) {
            return `${leg.expirationOffset.toString()}d`;
        }

        return `+${leg.expirationOffset}d`;
    }

    @DetectMethodChanges()
    setExpirationOffset(leg: PricingGridLegDescriptor | CustomHedgeLeg, args: DxValueChanged<string>
        , strategy?: PricingGridStrategy) {

        const regex = /^([+-])(\d+)d$/;

        if (regex.test(args.value)) {
            const num = parseInt(args.value);
            if (num !== leg.expirationOffset) {
                this._toastr.warning("Expiration offset input must be a plain number");
                args.component.option('value', args.previousValue);
            }
            return;
        }

        let newValueParsed = strictParseInt(args.value);

        if (!isValidNumber(newValueParsed, true)) {
            if (!isVoid(args.value)) {
                args.component.option('value', args.previousValue);
                return;
            }

            newValueParsed = null;
        }

        const prevValue = parseInt(args.previousValue);

        try {

            if (isValidNumber(newValueParsed, true)) {
                const providedSign = args.value[0];

                const existingValue = leg.expirationOffset;

                const isExistingValueValidNumber = isValidNumber(existingValue, true);

                if (!isExistingValueValidNumber) {
                    if (providedSign !== '+') {
                        newValueParsed = Math.abs(newValueParsed) * -1;
                    }
                } else {
                    const existingValueSign = Math.sign(existingValue);
                    if (providedSign !== '+' && providedSign !== '-') {
                        newValueParsed = Math.abs(newValueParsed) * existingValueSign;
                    }
                }
            }

        } finally {
            if (!isVoid(strategy)) {
                const pricingLeg = leg as PricingGridLegDescriptor;

                strategy.onExpirationOffsetChange(newValueParsed, pricingLeg);

                const event = {
                    event: 'ets',
                    value: newValueParsed,
                    previousValue: prevValue
                };

                strategy.onExpirationOffsetChanged(event, pricingLeg);
            }
        }
    }

    runTests() {
        this._opgTestingService.run(this);
    }

    //
    // OPG CoPilot host seam (CR-20260710-001)
    //

    // "X marks the spot" border registry (colId -> starting strike). Host state, NOT
    // cell state: with Live off a loaded strategy has no priced cell objects yet, so
    // the border must resolve from here at render time (cellClassRules in
    // options-pricing-grid-options.ts). Stays strike-only (no expiration term) under A5/WI-6:
    // a loaded trade only ever sits at its OWN bound date, because a cross-date preview
    // auto-un-previews every other-date trade (clearing its border) BEFORE it switches the
    // panel — so an X can never be left pointing at a foreign date.
    private _copilotBorders = new Map<string, number>();

    isCopilotBorderCell(params: CellClassParams): boolean {
        if (this.mode !== 'opg') {
            return false;
        }

        if (this._copilotBorders.size === 0) {
            return false;
        }

        const colId = params.colDef?.colId;

        if (isVoid(colId)) {
            return false;
        }

        if (!this._copilotBorders.has(colId)) {
            return false;
        }

        return this._copilotBorders.get(colId) === params.data?.rowStrike;
    }

    setBorder(strategyId: string, side: 'calls' | 'puts', strike: number): void {
        const colId = `pricing-${strategyId}-${side === 'calls' ? 'call' : 'put'}`;
        this._copilotBorders.set(colId, strike);
        this.refreshCopilotBorderCells([colId]);
    }

    clearBorder(strategyId: string): void {
        const colIds = [`pricing-${strategyId}-call`, `pricing-${strategyId}-put`]
            .filter(id => this._copilotBorders.delete(id));
        this.refreshCopilotBorderCells(colIds);
    }

    // Bulk clear — the SYMBOL-CHANGE path only (§8 part 1). A6/WI-15 removed the other caller: the
    // window close is a minimize now, and borders survive it along with everything else.
    clearAllBorders(): void {
        const colIds: string[] = [];
        this._copilotBorders.forEach((_, colId) => colIds.push(colId));
        this._copilotBorders.clear();
        this.refreshCopilotBorderCells(colIds);
    }

    private refreshCopilotBorderCells(colIds: string[]): void {
        if (colIds.length === 0) {
            return;
        }
        this._grid?.api?.refreshCells({force: true, columns: colIds});
    }

    // ---- IOpgCopilotFacade — entitlement + reads ------------------------------------------

    isOpgCoPilotAvailable(): boolean {
        // Entitlement gate (CR-20260710-001): OPG mode AND the granted secure-element. The 'pmd'
        // term keeps the FAB out of Position Modifier (shared base). The dev grant was flipped to
        // this real gate at CR close (2026-07-14); the FAB is now invisible until the secure-element
        // GUID is granted per terminal via CompanyServices. GUID registered in UIElement.cs (nested
        // under the OPG panel), mirrors APG's de8027a51 flip shape.
        return this.mode === 'opg' && this.accessControlService.isSecureElementAvailable('f02b3b2a-c8f2-43cb-9c8b-a6c2b5ea995a');
    }

    // VISIBLE-filtered (contract rule): non-visible expirations would be NULLED by the
    // expiration selector's setter and must never leak into the date block or skill context.
    readAvailableExpirations(): OptionExpirationDescriptor[] {
        return (this.availableExpirations || []).filter(x => x.visible);
    }

    // THE ANCHOR (A2): returned trades are expiration-relative to this.
    readSelectedExpirationDate(): string | null {
        return this.selectedExpiration ? this.selectedExpiration.optionExpirationDate : null;
    }

    readChosenAtm(): number {
        return this.centerStrike;
    }

    readDynamicAtm(): number {
        return this.getCurrentAtm();
    }

    readStrikeLadder(): number[] {
        return (this.pricingRows || []).map(x => x.rowStrike);
    }

    readDefaultQty(): number {
        return this.defaultQty;
    }


    readSymbol(): string | null {
        return this.tradingInstrument ? this.tradingInstrument.ticker : null;
    }

    // The strike pickers' [targetInstrument] (owner smoke 2026-07-10: pickers are the
    // platform ets-strikes-dropdown, HedgeMatrix Co-Pilot parity).
    readTradingInstrument(): TradingInstrument | null {
        return this.tradingInstrument || null;
    }

    // A trade-bound date resolved against the VISIBLE chain (CR-20260827-004: cards price at
    // their OWN date, never the panel's selected expiration); a real offset walks business
    // days from it — the same findOffsetExpiration rule the grid's calendarized columns use,
    // just anchored at the trade's date instead of the selection.
    readExpirationForTradeDate(dateKey: string | null, offset: number | null): OptionExpirationDescriptor | null {
        if (!dateKey) {
            return null;
        }
        const list = this.readAvailableExpirations();
        let descriptor: OptionExpirationDescriptor = null;
        for (let i = 0; i < list.length; i++) {
            if (list[i].optionExpirationDate === dateKey) {
                descriptor = list[i];
                break;
            }
        }
        if (!descriptor) {
            return null;
        }
        if (!isValidNumber(offset, true)) {
            return descriptor;
        }
        return findOffsetExpiration(descriptor, offset, this.optionChain) || null;
    }

    // ---- IOpgCopilotFacade — trade loading (the Hedge preview model: REAL strategies) ------

    // APPEND-only (§7 — never the saved-template load path's clearing step). Mints the
    // strategyId host-side: the PricingGridStrategy ctor ADOPTS a supplied descriptor id,
    // and that id is the §9 identity for the registry, the border colId, and unloadTrade.
    // templateId/templateName stay undefined — the CoPilot Template is NOT an OpgTemplate (§2).
    loadTrade(side: OpgSide, content: OpgTradeContent): string {
        const strategyId = getShortUUID();

        // WI-17/A9 — TRANSLATE THE LEG ORDER AT THIS SEAM. The two sides of it disagree, and
        // feeding the mold verbatim (as this did) was not a cosmetic slip — it loaded every CALL
        // strategy into the grid as the INVERSE spread.
        //
        //   The CoPilot's mold is ANCHOR-FIRST by contract: legs[0] sits on content.startingStrike
        //   and the widths walk outward from it — UP for calls (anchor = the LOWEST strike),
        //   DOWN for puts (anchor = the HIGHEST strike).
        //
        //   The OPG's descriptor is STRIKE-DESCENDING: the array is the display order (the
        //   strategy builder renders it top-down as-is) AND the column re-derives the anchor from
        //   it — setupColumnForOpgMode() REVERSES the array for calls before walking up from the
        //   row strike, so a call's anchor must be the array's LAST element. The paste-to-the-
        //   other-side path (this file, ~4090) reverses for the same reason: crossing sides flips
        //   the strike direction.
        //
        // For PUTS the two coincide (anchor = highest strike = first row), so only CALLS are
        // reversed. Without this, [Buy, w, Sell] anchored at 7515 came back as Sell 7515 / Buy 7525
        // — a short vertical where the card said long — and the builder listed calls bottom-up.
        // jsonCloneObject already returns a fresh array, so reversing it cannot touch content.legs.
        const legs = jsonCloneObject(content.legs);
        if (side === 'calls') {
            legs.reverse();
        }

        const descriptor: PricingGridStrategyDescriptor = {
            strategyId: strategyId,
            strategyName: content.name,
            selectedStrategy: content.mold,
            strategyLegs: legs,
            width: content.width,
            // CR-20260827-002 (contract v5): the engine's leg quantities are ABSOLUTE contract
            // counts — what will execute — so the strategy column must not scale them by the
            // grid's Default Qty (14 absolute at Default Qty 10 would become 140).
            absoluteQty: true
        };
        this.addStrategy(side, descriptor);
        return strategyId;
    }

    unloadTrade(side: OpgSide, strategyId: string): void {
        const container = side === 'calls' ? this.callStrategies : this.putStrategies;
        const strategy = container.find(x => x.strategyId === strategyId);
        if (strategy) {
            this.removeStrategy(side, strategy);
        }
    }

    // The loaded grid cell's price (already sign/scale-final via the StrategyPriceDto
    // pipeline) or null while unpriced (e.g. Live off — the trade "just sits there", §7).
    readLoadedTradePrice(side: OpgSide, strategyId: string, strike: number): number | null {
        if (!this._grid) {
            return null;
        }
        const node = this._grid.api.getRowNode('' + strike);
        if (!node || !node.data) {
            return null;
        }
        const col = node.data['pricing-' + strategyId + '-' + (side === 'calls' ? 'call' : 'put')];
        if (!col) {
            return null;
        }
        return isValidNumber(col.price) ? col.price : null;
    }

    // After CoPilot loads: price the side out if ITS Live toggle is already on. NEVER flips
    // Live itself (§3/§10 — Live stays the user's control).
    applySideIfLive(side: OpgSide): void {
        this.applyLiveIfPossible(side);
    }

    // ---- IOpgCopilotFacade — warned clear-on-run (WI-5) ------------------------------------

    // Any strategy loaded on EITHER side, CoPilot preview or user-built (the Run flow warns
    // before clearing when true). Reached only through the copilot orchestrator, which mounts
    // in 'opg' mode only — so, like loadTrade/unloadTrade, no extra mode gate is needed.
    hasAnyLoadedStrategies(): boolean {
        return (this.callStrategies || []).length > 0 || (this.putStrategies || []).length > 0;
    }

    // Remove EVERY strategy on both sides through removeStrategy — its border-clear (line ~1119)
    // and §8 hook (onHostStrategyRemoved) fire per strategy, so borders and previewed card states
    // clean up automatically. Iterate SLICE copies: removeStrategy splices the LIVE container, so
    // iterating it directly would shift indices and skip alternate entries.
    clearAllStrategies(): void {
        this.callStrategies.slice().forEach(s => this.removeStrategy('calls', s));
        this.putStrategies.slice().forEach(s => this.removeStrategy('puts', s));
    }

    // ---- CoPilot window (host-owned dx-popup; APG/Hedge recipe, CR-20260710-001) ------------

    @ViewChild(OpgCopilotComponent)
    opgCopilot: OpgCopilotComponent;

    copilotPopupVisible = false;

    // CoPilot FAB position (A7/WI-11). null = the CSS default (whole-panel bottom-right). A drag writes
    // {left, top} px here via (etsDraggablePositionChange); because it lives on the component (not the
    // FAB's DOM node) the moved position survives the FAB's *ngIf teardown when the popup opens. Session
    // only — no persistence, so a reload returns to the default corner.
    copilotFabPosition: { left: number; top: number } | null = null;

    // Stale-grid cue on the collapsed launcher (WI-15/A6): true while the CoPilot's captured grid state
    // (expiration / chosen ATM / default qty) no longer matches the live panel. The UNDERLYING is not
    // part of it — a symbol change resets the conversation, so its baseline dies with it.
    // Pushed up by the child's (staleChange) — the CoPilot owns the comparison, the host owns the FAB.
    copilotIsStale = false;

    // Popup pinned to the top, auto-fits the child's reported content height, growing
    // DOWNWARD until the bottom gap equals the top offset; then the child's dx-scroll-view
    // scrolls (duplicated from the APG/HG copilots).
    private static readonly COPILOT_TOP_OFFSET_PX = 24;
    private static readonly COPILOT_CHROME_PX = 56;
    private static readonly COPILOT_MIN_HEIGHT_PX = 240;
    // CR-20260715-001 owner smoke: the FOURTH Price Range pill ("Expected Range") wrapped the
    // segmented group. Owner-tuned live, several rounds. Final: 515 / 960.
    private static readonly COPILOT_WIDTH_NORMAL_PX = 515;
    private static readonly COPILOT_WIDTH_WIDE_PX = 960;   // Calls & Puts side-by-side (§5)

    copilotPopupPosition: any = {
        my: 'center top', at: 'center top', of: window,
        offset: {x: 0, y: OptionsPricingGridComponentBase.COPILOT_TOP_OFFSET_PX}
    };
    copilotPopupHeight = 420;   // seed; corrected to content on the first measure
    copilotPopupWidth = OptionsPricingGridComponentBase.COPILOT_WIDTH_NORMAL_PX;
    private _copilotContentHeight = 0;

    @DetectMethodChanges()
    openOpgCopilot(): void {
        this._applyCopilotPopupHeight();   // clamp the seed to the current window before the first measure
        this.copilotPopupVisible = true;
    }

    // dx-popup fully shown: the child manages its conversation + re-syncs its view (its
    // state survives close/reopen — deferRendering=false keeps it mounted).
    onCopilotShown(): void {
        this.opgCopilot?.onOpened();
        // Re-assert the window zoom + containment: the overlay element can be recreated when the
        // popup's *ngIf re-mounts it, and the edge strip must be (re)parented onto the overlay.
        this._orionWindow.apply();
    }

    // ---- ORION window chrome (shared zoom hatch + viewport containment) --------------------
    // Owner 2026-08-31: "this zoom hatch needs to be implemented for every copilot." Mechanism
    // (scale-transform zoom, ear drag, MutationObserver re-assert, viewport clamp) lives in the
    // shared OrionWindowController; these thin wrappers keep the template bindings +
    // @DetectMethodChanges (this host is OnPush).
    private readonly _orionWindow = new OrionWindowController(() => this.copilotPopupRef);

    @ViewChild('copilotPopupRef')
    copilotPopupRef: DxPopupComponent;

    get copilotZoomLevel(): number {
        return this._orionWindow.zoomLevel;
    }

    get copilotZoomPct(): number {
        return this._orionWindow.zoomPct;
    }

    @DetectMethodChanges()
    copilotZoomIn(): void {
        this._orionWindow.zoomIn();
    }

    @DetectMethodChanges()
    copilotZoomOut(): void {
        this._orionWindow.zoomOut();
    }

    @DetectMethodChanges()
    onCopilotZoomStripDblClick(ev: MouseEvent): void {
        this._orionWindow.onStripDblClick(ev);
    }

    onCopilotZoomStripPointerDown(ev: PointerEvent): void {
        this._orionWindow.onStripPointerDown(ev);
    }

    // Window close = MINIMIZE (amendment A6, owner 2026-07-14: "OPG Copilot must keep its state and
    // data until reset. Minimizing and restoring copilot must not affect entered data."). The whole
    // teardown is GONE — no session end, no border clear: entered questionnaires, results, previewed
    // cards, their X borders and any in-flight run all survive close→reopen. The session ends ONLY at
    // the CoPilot's refresh button (WI-10). This DELIBERATELY REVERSES the 2026-07-10 rule "window
    // close = borders gone + session reset, trades remain" and, with it, the BF-1 closed-window quote
    // release: the previewed trade cards now stay mounted while hidden and keep their per-leg quote
    // subscriptions ticking. That cost is accepted family-wide (the HedgeMatrix CoPilot pays the same
    // — its child is never torn down either) and is the price of a session that survives a minimize.
    @DetectMethodChanges()
    onCopilotHidden(): void {
        this.copilotPopupVisible = false;
    }

    // The CoPilot child reports that the live grid has drifted from the state it captured (WI-15).
    // Mirrored onto the collapsed launcher, which is the ONLY cue left once the window is shut.
    // @DetectMethodChanges because this host is OnPush and the event arrives from a child @Output
    // while the popup is closed — without the flush the FAB would not repaint.
    @DetectMethodChanges()
    onCopilotStaleChange(stale: boolean): void {
        this.copilotIsStale = stale;
    }

    @DetectMethodChanges()
    onCopilotWidthModeChange(mode: 'normal' | 'wide'): void {
        this.copilotPopupWidth = mode === 'wide'
            ? OptionsPricingGridComponentBase.COPILOT_WIDTH_WIDE_PX
            : OptionsPricingGridComponentBase.COPILOT_WIDTH_NORMAL_PX;
    }

    @DetectMethodChanges()
    onCopilotContentHeight(contentHeight: number): void {
        this._copilotContentHeight = contentHeight;
        this._applyCopilotPopupHeight();
    }

    private _applyCopilotPopupHeight(): void {
        const maxH = this._copilotMaxHeight();
        const desired = this._copilotContentHeight + OptionsPricingGridComponentBase.COPILOT_CHROME_PX;
        const min = OptionsPricingGridComponentBase.COPILOT_MIN_HEIGHT_PX;
        this.copilotPopupHeight = Math.max(min, Math.min(desired, maxH));
    }

    // maxHeight = the full window minus an equal gap top + bottom; floored at the min so a
    // very short window never collapses the popup.
    private _copilotMaxHeight(): number {
        const symmetric = window.innerHeight - 2 * OptionsPricingGridComponentBase.COPILOT_TOP_OFFSET_PX;
        return Math.max(OptionsPricingGridComponentBase.COPILOT_MIN_HEIGHT_PX, symmetric);
    }

    // Window resize changes the cap; re-clamp the live popup.
    @HostListener('window:resize')
    onCopilotWindowResize(): void {
        this._onCopilotWindowResizeImpl();
    }

    @DetectMethodChanges()
    private _onCopilotWindowResizeImpl(): void {
        if (this.copilotPopupVisible) {
            this._applyCopilotPopupHeight();
            // A resize (incl. browser-zoom changes) can shrink the viewport past the window's
            // position — re-clamp so the window stays fully inside it (CR HicgA7n5).
            this._orionWindow.clampNow();
        }
    }

    // ---- IOpgCopilotFacade — cross-date preview navigation (WI-6, A5) ----------------------

    // One-shot echo guard for the programmatic expiration switch below (read at the top of
    // onExpirationSelected). Holds the 'yyyy-MM-dd' key we are navigating TO; null when idle.
    private _copilotNavEchoKey: string | null = null;

    // A5/WI-6 (owner meeting 2, 2026-07-13) — SUPERSEDES the A2 rule that the CoPilot must NEVER
    // change the selected expiration (a navigateToExpiration was spiked here as SP-2, verified live
    // 2026-07-10, then removed under A2; this restores it in per-trade form). Switch the panel to a
    // previewed trade's bound expiration — the ONLY expiration change the CoPilot causes, driven
    // only by preview, never spontaneous. SP-2 recipe: the [(selectedExpiration)] two-way binding
    // owns the field and onExpirationSelected never self-assigns it, so assign the field FIRST,
    // THEN drive onExpirationSelected ourselves (event:'ets'); the arm swallows the selector's
    // possible echo. Returns false for an unknown/invisible date (the orchestrator aborts the
    // preview); true once applied.
    navigateToExpiration(dateKey: string): boolean {
        if (this.mode !== 'opg') {
            return false;
        }
        const target = this.readAvailableExpirations().find(x => x.optionExpirationDate === dateKey);
        if (isVoid(target)) {
            return false;   // unknown or non-visible expiration — no-op
        }
        const previousValue = this.selectedExpiration;
        if (previousValue && previousValue.optionExpirationDate === dateKey) {
            return true;   // already on this date — success, nothing to switch
        }
        // Arm BEFORE the assignment so even a synchronous echo is caught; our own event:'ets' call
        // below is let through by the guard (see the top of onExpirationSelected).
        this._copilotNavEchoKey = dateKey;
        this.selectedExpiration = target;
        this.onExpirationSelected({value: target, previousValue: previousValue, event: 'ets'});
        return true;
    }

}
